import { useState, useRef, Fragment } from 'react'
import { SITES, ALL_ATELIERS, SITE_DISABLED_ATELIERS } from '../../config/sitesConfig'
import PXTKPanel  from './panels/PXTKPanel'
import PXLGPanel  from './panels/PXLGPanel'
import PXLTPanel  from './panels/PXLTPanel'
import PXCTPanel  from './panels/PXCTPanel'
import PXKhiPanel from './panels/PXKhiPanel'
import PXHQPanel  from './panels/PXHQPanel'


// ─── Mock data ────────────────────────────────────────────
const DASHBOARDS_SITE = [
  { id:0, label:"Bảng điều khiển",        icon:"⭐", subtitle:"Default dashboard of the account" },
  { id:1, label:"2. CO2 emissions", icon:null },
]

const SITE_NAV = ["Tổng quan","Lưu Trình Công Nghệ","Kế hoạch","Địa điểm tôi","Cam kết","Nhập thủ công","Báo cáo"]

const MONTHS_ABBR = ["Jul","Aug","Sep","Oct","Nov","Dec","Jan","Feb","Mar","Apr","May","Jun"]
const GAS_N1   = [40,35,30,80,120,100,95,85,60,50,40,30]
const ELEC_N1  = [20,18,15,40,60,50,45,40,30,25,20,15]
const GAS_CUR  = [35,30,25,90,140,110,100,90,70,55,40,28]
const ELEC_CUR = [18,15,12,45,70,55,50,42,35,28,20,14]

const CO2_MONTHS = ["Jul","Sep","Nov","Jan","Mar","May"]
const CO2_ELEC   = [1.2,1.1,2.5,3.8,3.2,2.0]
const CO2_GAS    = [0.4,0.3,0.8,1.2,1.0,0.6]
const CO2_BUDGET = [4.0,4.0,4.0,4.0,4.0,4.0]

const ACTIONS_SITE = [
  { title:"Hẹn giờ chiếu sáng...", date:"27/07/2022", status:"Đang làm", user:"JU" },
  { title:"Audit thermiq...", date:"05/08/2022", status:"Cần làm",       user:"JU" },
  { title:"Encourager le...", date:"",           status:"Cần làm",       user:"JU" },
  { title:"Relamping LED",   date:"",           status:"Cần làm",       user:"JU" },
]

const ENERGY_LABELS = ["A","B","C","D","E","F"]
const ENERGY_COLORS = ["#22c55e","#86efac","#fbbf24","#f97316","#ef4444","#dc2626"]
// purple palette for CO2 labels
const CO2_COLORS    = ["#7c3aed","#8b5cf6","#a78bfa","#c4b5fd","#ddd6fe","#ede9fe"]

const CALENDAR_MONTHS = ["January","February","March","April","May","June","July","August","September","October","November","December"]
const YEARS = [2019,2020,2021,2022,2023,2024]

// ─── Period Picker Modal ──────────────────────────────────
function PeriodPicker({ onClose, onApply, current }) {
  const [selectedYear, setSelectedYear]     = useState(2024)
  const [calMonth,     setCalMonth]         = useState(5)   // June 2024
  const [calYear,      setCalYear]          = useState(2024)
  const [selectedDay,  setSelectedDay]      = useState(6)

  const daysInMonth = new Date(calYear, calMonth+1, 0).getDate()
  const firstDay    = new Date(calYear, calMonth, 1).getDay() // 0=Sun
  const startOffset = firstDay === 0 ? 6 : firstDay - 1      // Mon=0

  const weeks = []
  let day = 1 - startOffset
  for (let w=0; w<6; w++) {
    const week = []
    for (let d=0; d<7; d++) { week.push(day); day++ }
    if (week.some(d=>d>=1&&d<=daysInMonth)) weeks.push(week)
  }

  return (
    <div style={{
      position:"fixed",inset:0,background:"rgba(0,0,0,0.4)",
      display:"flex",alignItems:"center",justifyContent:"center",zIndex:1000
    }} onClick={e=>{if(e.target===e.currentTarget)onClose()}}>
      <div style={{background:"white",borderRadius:12,width:600,boxShadow:"0 20px 60px rgba(0,0,0,0.25)",overflow:"hidden"}}>

        {/* Header */}
        <div style={{background:"#2563eb",color:"white",padding:"14px 20px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <span style={{fontWeight:700,fontSize:14,letterSpacing:.5}}>DEFAULT PERIODS</span>
          <button onClick={onClose} style={{background:"none",border:"none",color:"white",cursor:"pointer",fontSize:18,lineHeight:1}}>×</button>
        </div>

        <div style={{display:"flex",gap:0}}>

          {/* Left — A YEAR + A MONTH */}
          <div style={{flex:1,padding:"20px 20px 16px",borderRight:"1px solid #e2e8f0"}}>

            {/* A YEAR */}
            <div style={{marginBottom:16}}>
              <div style={{fontSize:10,fontWeight:700,color:"#94a3b8",letterSpacing:1,marginBottom:10}}>A YEAR</div>
              <div style={{display:"flex",alignItems:"center",gap:4,flexWrap:"wrap"}}>
                <button style={{background:"none",border:"none",cursor:"pointer",color:"#64748b",fontSize:14}}>◀</button>
                {YEARS.map(y=>(
                  <button key={y} onClick={()=>setSelectedYear(y)} style={{
                    padding:"4px 8px",borderRadius:6,border:"none",cursor:"pointer",
                    fontSize:12,fontWeight:y===selectedYear?700:400,
                    background:y===selectedYear?"#2563eb":"transparent",
                    color:y===selectedYear?"white":"#374151",transition:"all .15s"
                  }}>{y}</button>
                ))}
                <button style={{background:"none",border:"none",cursor:"pointer",color:"#64748b",fontSize:14}}>▶</button>
              </div>
            </div>

            {/* Date range display */}
            <div style={{background:"#f8fafc",border:"1px solid #e2e8f0",borderRadius:6,padding:"8px 12px",marginBottom:16,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <span style={{fontSize:12,color:"#374151"}}>01/05/2024 - 30/04/2025</span>
              <span style={{color:"#94a3b8",fontSize:12}}>▾</span>
            </div>

            {/* A MONTH */}
            <div>
              <div style={{fontSize:10,fontWeight:700,color:"#94a3b8",letterSpacing:1,marginBottom:10}}>A MONTH</div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:2}}>
                {CALENDAR_MONTHS.map((m,i)=>{
                  const yr = i<6 ? [2024,2023,2022,2021,2020,2019][Math.floor(i/1)%6] : [2024,2023,2022,2021,2020,2019][Math.floor((i-6)/1)%6]
                  const displayYr = i < 6 ? [2024,2023,2022,2021,2020,2019][i] : [2023,2022,2021,2020,2019,2018][i-6]
                  return (
                    <button key={m} style={{
                      display:"flex",justifyContent:"space-between",padding:"4px 8px",
                      borderRadius:4,border:"none",cursor:"pointer",
                      background:"transparent",fontSize:11,
                      color:"#374151",transition:"background .1s"
                    }}
                      onMouseEnter={e=>e.currentTarget.style.background="#f1f5f9"}
                      onMouseLeave={e=>e.currentTarget.style.background="transparent"}
                    >
                      <span>{m}</span>
                      <span style={{color:"#94a3b8"}}>{displayYr}</span>
                    </button>
                  )
                })}
              </div>
            </div>
          </div>

          {/* Right — A DAY OR A WEEK (calendar) */}
          <div style={{flex:1,padding:"20px 20px 16px"}}>
            <div style={{fontSize:10,fontWeight:700,color:"#94a3b8",letterSpacing:1,marginBottom:12}}>A DAY OR A WEEK</div>

            {/* Month nav */}
            <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:12}}>
              <button onClick={()=>{if(calMonth===0){setCalMonth(11);setCalYear(y=>y-1)}else setCalMonth(m=>m-1)}}
                style={{background:"none",border:"none",cursor:"pointer",color:"#64748b",fontSize:16}}>◀</button>
              <span style={{fontWeight:700,fontSize:13,color:"#0f172a"}}>{CALENDAR_MONTHS[calMonth]} {calYear}</span>
              <button onClick={()=>{if(calMonth===11){setCalMonth(0);setCalYear(y=>y+1)}else setCalMonth(m=>m+1)}}
                style={{background:"none",border:"none",cursor:"pointer",color:"#64748b",fontSize:16}}>▶</button>
            </div>

            {/* Day headers */}
            <div style={{display:"grid",gridTemplateColumns:"repeat(8,1fr)",gap:2,marginBottom:4}}>
              <div style={{fontSize:9,color:"#94a3b8",textAlign:"center"}}>Wk</div>
              {["Mo","Tu","We","Th","Fr","Sa","Su"].map(d=>(
                <div key={d} style={{fontSize:9,color:"#94a3b8",textAlign:"center",fontWeight:600}}>{d}</div>
              ))}
            </div>

            {/* Weeks */}
            {weeks.map((week,wi)=>{
              const weekNum = wi + 22
              return (
                <div key={wi} style={{display:"grid",gridTemplateColumns:"repeat(8,1fr)",gap:2,marginBottom:2}}>
                  <div style={{fontSize:9,color:"#94a3b8",textAlign:"center",display:"flex",alignItems:"center",justifyContent:"center"}}>{weekNum}</div>
                  {week.map((d,di)=>{
                    const valid = d>=1 && d<=daysInMonth
                    const isSelected = d===selectedDay && valid
                    return (
                      <button key={di} onClick={()=>valid&&setSelectedDay(d)} style={{
                        height:24,borderRadius:4,border:"none",cursor:valid?"pointer":"default",
                        background:isSelected?"#2563eb":"transparent",
                        color:isSelected?"white":valid?"#374151":"#d1d5db",
                        fontSize:11,fontWeight:isSelected?700:400,
                        transition:"background .1s"
                      }}
                        onMouseEnter={e=>{if(valid&&!isSelected)e.currentTarget.style.background="#f1f5f9"}}
                        onMouseLeave={e=>{if(!isSelected)e.currentTarget.style.background="transparent"}}
                      >{valid?d:""}</button>
                    )
                  })}
                </div>
              )
            })}
          </div>
        </div>

        {/* Footer */}
        <div style={{padding:"12px 20px",borderTop:"1px solid #e2e8f0",display:"flex",justifyContent:"center",gap:12}}>
          <button onClick={onClose} style={{
            width:36,height:36,borderRadius:"50%",background:"#fee2e2",border:"none",
            cursor:"pointer",fontSize:18,color:"#ef4444",display:"flex",alignItems:"center",justifyContent:"center"
          }}>×</button>
          <button onClick={()=>onApply(`01/06/${calYear} - 30/06/${calYear}`)} style={{
            width:36,height:36,borderRadius:"50%",background:"#dcfce7",border:"none",
            cursor:"pointer",fontSize:18,color:"#22c55e",display:"flex",alignItems:"center",justifyContent:"center"
          }}>✓</button>
        </div>
      </div>
    </div>
  )
}

// ─── Widget ───────────────────────────────────────────────
function Widget({ title, date, children, cols=1, minH=200, accent="#2563eb", topRight, onDateClick }) {
  return (
    <div style={{
      gridColumn:`span ${cols}`,background:"white",borderRadius:10,
      boxShadow:"0 1px 4px rgba(0,0,0,0.07)",border:"1px solid #f1f5f9",
      padding:16,display:"flex",flexDirection:"column",gap:10,minHeight:minH,
      transition:"box-shadow .2s",
    }}
      onMouseEnter={e=>e.currentTarget.style.boxShadow="0 4px 14px rgba(0,0,0,0.1)"}
      onMouseLeave={e=>e.currentTarget.style.boxShadow="0 1px 4px rgba(0,0,0,0.07)"}
    >
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <div style={{display:"flex",alignItems:"center",gap:8}}>
          <div style={{width:10,height:10,borderRadius:"50%",background:accent}}/>
          <span style={{fontWeight:600,fontSize:13,color:"#0f172a",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{title}</span>
        </div>
        <div style={{display:"flex",alignItems:"center",gap:6,flexShrink:0}}>
          {topRight}
          <button style={{background:"none",border:"none",cursor:"pointer",color:"#94a3b8",fontSize:13}}>⤢</button>
          <button style={{background:"none",border:"none",cursor:"pointer",color:"#94a3b8",fontSize:13}}>⋯</button>
        </div>
      </div>
      {date && (
        <div onClick={onDateClick} style={{
          fontSize:11,color:"#64748b",display:"flex",alignItems:"center",gap:5,
          cursor:onDateClick?"pointer":"default",
          padding:onDateClick?"2px 6px":"0",borderRadius:4,
          transition:"background .15s",width:"fit-content"
        }}
          onMouseEnter={e=>{if(onDateClick)e.currentTarget.style.background="#f1f5f9"}}
          onMouseLeave={e=>e.currentTarget.style.background="transparent"}
        >
          <span>📅</span>{date}
        </div>
      )}
      <div style={{flex:1}}>{children}</div>
    </div>
  )
}

// ─── Energy Class Widget ──────────────────────────────────
function EnergyClassWidget({ site, colorSet=ENERGY_COLORS, unit="kWh/m²" }) {
  return (
    <div style={{display:"flex",gap:16,alignItems:"flex-start",padding:"4px 0"}}>
      <div style={{display:"flex",flexDirection:"column",gap:3}}>
        {ENERGY_LABELS.map((l,i)=>(
          <div key={l} style={{display:"flex",alignItems:"center",gap:4}}>
            <div style={{
              background:colorSet[i],color:"white",fontWeight:700,
              width:28+i*5,height:20,display:"flex",alignItems:"center",justifyContent:"center",
              fontSize:10,borderRadius:2,
              clipPath:"polygon(0 0,calc(100% - 6px) 0,100% 50%,calc(100% - 6px) 100%,0 100%)"
            }}>{l}</div>
            {l===site.energyClass&&(
              <span style={{fontSize:11,fontWeight:700,color:"#0f172a",background:"#f0fdf4",padding:"1px 5px",borderRadius:3}}>
                {site.classValue}
              </span>
            )}
          </div>
        ))}
      </div>
      <div style={{borderLeft:"1px solid #e2e8f0",paddingLeft:14}}>
        <div style={{fontSize:10,color:"#64748b",marginBottom:6}}>Emission per m²</div>
        <div style={{display:"flex",alignItems:"center",gap:6}}>
          <div style={{
            background:"#7c3aed",color:"white",fontWeight:700,
            width:22,height:18,display:"flex",alignItems:"center",justifyContent:"center",
            fontSize:9,borderRadius:2
          }}>A</div>
          <span style={{fontSize:20,fontWeight:800,color:"#0f172a"}}>{site.co2}</span>
          <span style={{fontSize:9,color:"#64748b"}}>kg…</span>
        </div>
      </div>
    </div>
  )
}

// ─── Donut Chart ─────────────────────────────────────────
function DonutChart({ value=97.28, color="#22c55e", size=110, label="" }) {
  const r=36,cx=55,cy=55,sw=14,c=2*Math.PI*r,dash=(value/100)*c
  return (
    <svg viewBox="0 0 110 110" style={{width:size,height:size}}>
      <circle cx={cx} cy={cy} r={r} fill="none" stroke="#e2e8f0" strokeWidth={sw}/>
      <circle cx={cx} cy={cy} r={r} fill="none" stroke={color} strokeWidth={sw}
        strokeDasharray={`${dash} ${c-dash}`} strokeDashoffset={c/4} strokeLinecap="round"/>
      <text x={cx} y={cy+4} textAnchor="middle" fontSize={12} fontWeight="800" fill="#0f172a">{value}%</text>
      {label&&<text x={cx} y={cy+16} textAnchor="middle" fontSize={7} fill="#64748b">{label}</text>}
    </svg>
  )
}

// ─── CO2 Budget Control Donut ─────────────────────────────
function BudgetDonut({ value=0.2 }) {
  const r=36,cx=55,cy=55,sw=12,c=2*Math.PI*r,dash=(value/100)*c*100
  return (
    <div style={{position:"relative",width:110,height:110}}>
      <svg viewBox="0 0 110 110" style={{width:110,height:110}}>
        <circle cx={cx} cy={cy} r={r} fill="none" stroke="#e2e8f0" strokeWidth={sw}/>
        <circle cx={cx} cy={cy} r={r} fill="none" stroke="#22c55e" strokeWidth={sw}
          strokeDasharray={`${dash} ${c-dash}`} strokeDashoffset={c/4} strokeLinecap="round"/>
        <text x={cx} y={cy+4} textAnchor="middle" fontSize={13} fontWeight="800" fill="#0f172a">{value}%</text>
      </svg>
      {[{pct:"90%",y:14},{pct:"70%",y:74},{pct:"50%",y:98}].map(p=>(
        <div key={p.pct} style={{
          position:"absolute",right:-18,top:p.y,fontSize:8,color:"#94a3b8"
        }}>{p.pct}</div>
      ))}
    </div>
  )
}

// ─── Stacked Bar Chart (Consumption) ─────────────────────
function ConsumptionChart() {
  const maxVal=Math.max(...GAS_CUR,...ELEC_CUR,...GAS_N1,...ELEC_N1),H=90
  return (
    <div>
      <div style={{display:"flex",alignItems:"flex-end",gap:4,height:H+4}}>
        {MONTHS_ABBR.map((m,i)=>{
          const gN1=(GAS_N1[i]/maxVal)*H,eN1=(ELEC_N1[i]/maxVal)*H
          const gC=(GAS_CUR[i]/maxVal)*H,eC=(ELEC_CUR[i]/maxVal)*H
          return (
            <div key={m} style={{display:"flex",alignItems:"flex-end",gap:1,flex:1}}>
              <div style={{flex:1,display:"flex",flexDirection:"column",alignItems:"stretch"}}>
                <div style={{height:eN1,background:"#86efac",borderRadius:"2px 2px 0 0"}}/>
                <div style={{height:gN1,background:"#fde68a"}}/>
              </div>
              <div style={{flex:1,display:"flex",flexDirection:"column",alignItems:"stretch"}}>
                <div style={{height:eC,background:"#22c55e",borderRadius:"2px 2px 0 0"}}/>
                <div style={{height:gC,background:"#f59e0b"}}/>
              </div>
            </div>
          )
        })}
      </div>
      <div style={{display:"flex",gap:4,marginTop:4}}>
        {MONTHS_ABBR.map(m=><div key={m} style={{flex:1,fontSize:8,color:"#64748b",textAlign:"center"}}>{m}</div>)}
      </div>
      <div style={{display:"flex",gap:10,marginTop:8,flexWrap:"wrap"}}>
        {[{c:"#fde68a",l:"Gas (N-1)"},{c:"#86efac",l:"Electricity (N-1)"},{c:"#f59e0b",l:"Gas"},{c:"#22c55e",l:"Điện"}].map(l=>(
          <div key={l.l} style={{display:"flex",alignItems:"center",gap:4,fontSize:9,color:"#64748b"}}>
            <div style={{width:9,height:9,background:l.c,borderRadius:2}}/>{l.l}
          </div>
        ))}
      </div>
    </div>
  )
}

// ─── CO2 Cumulated Area Chart ─────────────────────────────
function CO2Chart() {
  const maxVal=5,H=90,W=300
  const pad={l:24,r:8,t:4,b:20}
  const iW=W-pad.l-pad.r,iH=H-pad.t-pad.b
  const n=CO2_MONTHS.length
  const sx=i=>pad.l+(i/(n-1))*iW
  const sy=v=>pad.t+iH-(v/maxVal)*iH

  const elecPts=CO2_ELEC.map((v,i)=>`${sx(i)},${sy(v)}`).join(" ")
  const gasPts=CO2_GAS.map((v,i)=>`${sx(i)},${sy(v)}`).join(" ")
  const budgetPts=CO2_BUDGET.map((v,i)=>`${sx(i)},${sy(v)}`).join(" ")

  // filled area for electricity
  const elecArea=`${sx(0)},${sy(0)} ${elecPts} ${sx(n-1)},${sy(0)}`
  const gasArea=`${sx(0)},${sy(0)} ${gasPts} ${sx(n-1)},${sy(0)}`

  return (
    <div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:"100%",height:H}}>
        {[0,1,2,3,4,5].map(v=>(
          <line key={v} x1={pad.l} y1={sy(v)} x2={W-pad.r} y2={sy(v)} stroke="#f1f5f9" strokeWidth={0.5}/>
        ))}
        {/* Electricity area */}
        <polygon points={elecArea} fill="#22c55e" opacity={0.35}/>
        <polyline points={elecPts} fill="none" stroke="#22c55e" strokeWidth={1.5}/>
        {/* Gas area */}
        <polygon points={gasArea} fill="#f59e0b" opacity={0.35}/>
        <polyline points={gasPts} fill="none" stroke="#f59e0b" strokeWidth={1.5}/>
        {/* Budget line */}
        <polyline points={budgetPts} fill="none" stroke="#ef4444" strokeWidth={1.5} strokeDasharray="4,3"/>
        {/* X axis labels */}
        {CO2_MONTHS.map((m,i)=>(
          <text key={m} x={sx(i)} y={H-4} textAnchor="middle" fontSize={8} fill="#94a3b8">{m}</text>
        ))}
        {/* Y axis */}
        {[0,250,500,750].map((v,i)=>(
          <text key={v} x={pad.l-2} y={sy(v/150)} textAnchor="end" fontSize={7} fill="#94a3b8">{v}</text>
        ))}
      </svg>
      <div style={{display:"flex",gap:12,marginTop:6,flexWrap:"wrap"}}>
        {[{c:"#22c55e",l:"Điện"},{c:"#f59e0b",l:"Khí thiên nhiên"},{c:"#ef4444",l:"Yearly CO2 budget",dash:true}].map(l=>(
          <div key={l.l} style={{display:"flex",alignItems:"center",gap:4,fontSize:9,color:"#64748b"}}>
            <div style={{width:16,height:3,background:l.c,borderRadius:2,borderTop:l.dash?"1px dashed "+l.c:"none"}}/>{l.l}
          </div>
        ))}
      </div>
    </div>
  )
}

// ─── Overview Dashboard (default) ────────────────────────
function OverviewDashboard({ site, period, onDateClick }) {
  return (
    <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:12}}>
      <Widget title="Hạng năng lượng" date={period} onDateClick={onDateClick} minH={200}>
        <EnergyClassWidget site={site} colorSet={ENERGY_COLORS} unit="kWh/m²"/>
      </Widget>
      <Widget title="Tiết kiệm năng lượng" date={period} onDateClick={onDateClick} minH={200}>
        <div style={{display:"flex",alignItems:"center",justifyContent:"center",height:"100%",flexDirection:"column",gap:10}}>
          <div style={{fontSize:34,fontWeight:900,color:"#94a3b8"}}>— —%</div>
          <div style={{background:"#fef3c7",border:"1px solid #fde68a",borderRadius:6,padding:"8px 12px",fontSize:10,color:"#92400e",display:"flex",gap:8,alignItems:"flex-start"}}>
            <span style={{fontSize:14,flexShrink:0}}>⚠</span>
            <span>The gauge cannot be displayed because the indicator is negative or higher than 100%</span>
          </div>
        </div>
      </Widget>
      <Widget title="Hành động..." minH={200}>
        <ActionList items={ACTIONS_SITE} siteId={site.id}/>
      </Widget>
      <Widget title="Tiêu thụ năng lượng" date={period} onDateClick={onDateClick} cols={2} minH={220}
        topRight={<span style={{fontSize:10,color:"#64748b"}}>Aggregation per month ▾</span>}>
        <div style={{position:"relative"}}>
          <button style={{position:"absolute",left:-6,top:"40%",background:"none",border:"none",cursor:"pointer",fontSize:16,color:"#94a3b8",zIndex:2}}>‹</button>
          <ConsumptionChart/>
          <button style={{position:"absolute",right:-6,top:"40%",background:"none",border:"none",cursor:"pointer",fontSize:16,color:"#94a3b8",zIndex:2}}>›</button>
        </div>
      </Widget>
      <Widget title="Ghi chú" minH={150}>
        <div style={{background:"#fef9c3",borderRadius:6,padding:12,fontSize:11,color:"#374151",lineHeight:1.7}}>
          Remember to plan a technical visit for the installation of new energy consumptions monitoring devices
        </div>
      </Widget>
    </div>
  )
}

// ─── CO2 Dashboard ────────────────────────────────────────
function CO2SiteDashboard({ site, period, onDateClick }) {
  return (
    <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12}}>

      {/* Environmental performance */}
      <Widget title="Hiệu suất môi trường..." date={period} onDateClick={onDateClick} minH={220}>
        <EnergyClassWidget site={site} colorSet={CO2_COLORS} unit="kgCO₂/m²"/>
      </Widget>

      {/* CO2 emissions per energy */}
      <Widget title="Phát thải CO₂ theo năng lượng" date={period} onDateClick={onDateClick} minH={220}>
        <div style={{textAlign:"center"}}>
          <div style={{fontSize:11,color:"#64748b",marginBottom:4,textAlign:"left"}}>Tổng</div>
          <div style={{fontSize:22,fontWeight:800,color:"#f59e0b",marginBottom:6,textAlign:"left"}}>
            1,04 <span style={{fontSize:12,fontWeight:400,color:"#64748b"}}>tCO₂eq</span>
          </div>
          {/* Pie chart */}
          <div style={{position:"relative",display:"inline-block"}}>
            <DonutChart value={97.28} color="#22c55e" size={110}/>
          </div>
          <div style={{fontSize:10,marginTop:8,textAlign:"left",display:"flex",flexDirection:"column",gap:3}}>
            <div style={{display:"flex",gap:6,alignItems:"center"}}>
              <div style={{width:8,height:8,background:"#22c55e",borderRadius:2}}/>
              <span>Electricity  1.02 tCO₂eq</span>
            </div>
            <div style={{display:"flex",gap:6,alignItems:"center"}}>
              <div style={{width:8,height:8,background:"#f59e0b",borderRadius:2}}/>
              <span>Natural gas  0.03 tCO₂eq</span>
            </div>
          </div>
        </div>
      </Widget>

      {/* CO2 budget control */}
      <Widget title="Kiểm soát ngân sách CO₂" date={period} onDateClick={onDateClick} minH={220}>
        <div style={{display:"flex",alignItems:"center",justifyContent:"center",height:"100%"}}>
          <BudgetDonut value={0.2}/>
        </div>
      </Widget>

      {/* Carbon action plan */}
      <Widget title="Kế hoạch carbon" minH={220}>
        <ActionList items={ACTIONS_SITE} siteId={site.id}/>
      </Widget>

      {/* Total CO2 */}
      <Widget title="Tổng phát thải CO₂" date={period} onDateClick={onDateClick} minH={150}>
        <div style={{display:"flex",alignItems:"baseline",gap:8,paddingTop:12}}>
          <span style={{fontSize:36,fontWeight:900,color:"#0f172a",letterSpacing:-1}}>1</span>
          <span style={{fontSize:16,color:"#64748b"}}>tCO₂eq</span>
        </div>
      </Widget>

      {/* Cumulated CO2 chart */}
      <Widget title="Phát thải CO₂ tích lũy so với ngân sách năm" date={period} onDateClick={onDateClick}
        cols={2} minH={220}
        topRight={<span style={{fontSize:10,color:"#64748b"}}>Aggregation per month ▾</span>}>
        <div style={{position:"relative"}}>
          <button style={{position:"absolute",left:-6,top:"40%",background:"none",border:"none",cursor:"pointer",fontSize:16,color:"#94a3b8",zIndex:2}}>‹</button>
          <CO2Chart/>
          <button style={{position:"absolute",right:-6,top:"40%",background:"none",border:"none",cursor:"pointer",fontSize:16,color:"#94a3b8",zIndex:2}}>›</button>
        </div>
      </Widget>

      {/* Note */}
      <Widget title="Ghi chú" minH={220}>
        <div style={{background:"#fef9c3",borderRadius:6,padding:12,fontSize:10,color:"#374151",lineHeight:1.75}}>
          <p style={{marginBottom:8}}>The yearly CO2 budget is almost overspent: the natural gas has a great impact on the site's CO2 emissions.</p>
          <p>A technical study is in progress to improve the site's energy efficiency and investigate the possibility to install less carbon-intensive energy equipments.</p>
        </div>
      </Widget>

      {/* Total surface */}
      <Widget title="Tổng diện tích" date={period} onDateClick={onDateClick} minH={120}>
        <div style={{display:"flex",alignItems:"baseline",gap:8,paddingTop:8}}>
          <span style={{fontSize:36,fontWeight:900,color:"#0f172a",letterSpacing:-1}}>{site.totalSurf.toLocaleString()}</span>
          <span style={{fontSize:16,color:"#64748b"}}>m²</span>
        </div>
      </Widget>
    </div>
  )
}

// ─── Action List ─────────────────────────────────────────
function ActionList({ items, siteId }) {
  return (
    <div style={{display:"flex",flexDirection:"column"}}>
      {items.map((a,i)=>(
        <div key={i} style={{padding:"7px 0",borderBottom:"1px solid #f8fafc",display:"flex",alignItems:"center",gap:8}}>
          <span style={{color:a.status==="Đang làm"?"#ef4444":"#64748b",fontSize:12,flexShrink:0}}>↑</span>
          <div style={{flex:1,minWidth:0}}>
            <div style={{display:"flex",justifyContent:"space-between",gap:4}}>
              <span style={{fontSize:11,fontWeight:600,color:"#0f172a",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{a.title}</span>
              <span style={{fontSize:9,color:"#ef4444",flexShrink:0,fontWeight:500}}>{a.date}</span>
            </div>
            <div style={{display:"flex",gap:5,marginTop:2}}>
              <span style={{
                fontSize:9,padding:"1px 5px",borderRadius:3,fontWeight:600,flexShrink:0,
                background:a.status==="Đang làm"?"#fef3c7":"#dbeafe",
                color:a.status==="Đang làm"?"#92400e":"#1d4ed8"
              }}>{a.status}</span>
              <span style={{fontSize:9,color:"#94a3b8",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{siteId} - Siège so...</span>
            </div>
          </div>
          <div style={{width:22,height:22,borderRadius:"50%",background:"#2563eb",display:"flex",alignItems:"center",justifyContent:"center",fontSize:9,fontWeight:700,color:"white",flexShrink:0}}>{a.user}</div>
        </div>
      ))}
    </div>
  )
}

// ─── Action Plan Kanban ───────────────────────────────────
const ACTION_TYPES = ["Nâng cao nhận thức","Can thiệp","Công việc","Nghiên cứu"]
const TYPE_COLORS  = { Awareness:"#2563eb", Intervention:"#8b5cf6", Works:"#f59e0b", Study:"#06b6d4" }

const KANBAN_DATA = {
  "Cần làm": [
    { id:1, title:"Kiểm toán nhiệt",          date:"05/08/2022", type:"Nghiên cứu",        user:"JU", priority:"high",
      assignee:"Nguyễn Văn An", startDate:"01/08/2022", initialDeadline:"05/08/2022", actualDeadline:"", energyImpact:false, description:"", labels:"" },
    { id:2, title:"Khuyến khích làm việc từ xa", date:"",           type:"Nâng cao nhận thức",    user:"JU", priority:"low",
      assignee:"Nguyễn Văn An", startDate:"", initialDeadline:"", actualDeadline:"", energyImpact:false, description:"", labels:"" },
    { id:3, title:"Relamping LED",             date:"",           type:"Công việc",        user:"JU", priority:"low",
      assignee:"Nguyễn Văn An", startDate:"", initialDeadline:"", actualDeadline:"", energyImpact:false, description:"", labels:"" },
  ],
  "Đang làm": [
    { id:4, title:"Hẹn giờ chiếu sáng",        date:"27/07/2022", type:"Công việc",        user:"JU", priority:"high",
      assignee:"Nguyễn Văn An", startDate:"01/07/2022", initialDeadline:"27/07/2022", actualDeadline:"", energyImpact:true,  description:"", labels:"" },
  ],
  "Hoàn thành": [
    { id:5, title:"Nâng cao nhận thức người dùng...", date:"01/02/2022", type:"Nâng cao nhận thức",    user:"JU", priority:"low",
      assignee:"Nguyễn Văn An", startDate:"01/01/2022", initialDeadline:"01/02/2022", actualDeadline:"01/02/2022", energyImpact:false, description:"", labels:"" },
    { id:6, title:"Giảm nhiệt độ cài đặt...",  date:"20/05/2022", type:"Can thiệp", user:"JU", priority:"mid",
      assignee:"Nguyễn Văn An", startDate:"01/04/2022", initialDeadline:"20/05/2022", actualDeadline:"20/05/2022", energyImpact:true,  description:"", labels:"" },
  ],
}

const STATUS_COLORS = {
  "Cần làm":      { bg:"#2563eb", text:"white" },
  "Đang làm":{ bg:"#f59e0b", text:"white" },
  "Hoàn thành":       { bg:"#22c55e", text:"white" },
}

// ─── Action Task Detail Screen ────────────────────────────
const STATUSES = ["Cần làm","Đang làm","Hoàn thành"]
const STATUS_DOT = { "Cần làm":"#cbd5e1", "Đang làm":"#f59e0b", "Hoàn thành":"#22c55e" }

function ActionTaskDetail({ card, colStatus, onBack }) {
  const [form, setForm] = useState({
    name:            card.title,
    type:            card.type,
    priority:        card.priority==="high"?"Quan trọng":card.priority==="mid"?"Nhỏ":"Thấp",
    description:     card.description||"",
    labels:          card.labels||"",
    status:          colStatus,
    assignee:        card.assignee||"Nguyễn Văn An",
    startDate:       card.startDate||"",
    initialDeadline: card.initialDeadline||"",
    actualDeadline:  card.actualDeadline||"",
    cost:            "",
    expectedGain:    "",
    actualGain:      "",
    energyImpact:    card.energyImpact||false,
  })
  const set = (k,v) => setForm(f=>({...f,[k]:v}))

  const inputStyle = {
    border:"1px solid #e2e8f0",borderRadius:6,padding:"6px 10px",
    fontSize:12,color:"#0f172a",background:"white",outline:"none",width:"100%",boxSizing:"border-box"
  }
  const labelStyle = { fontSize:12,color:"#64748b",width:130,flexShrink:0,paddingTop:7 }
  const rowStyle   = { display:"flex",alignItems:"flex-start",gap:12,marginBottom:14 }

  return (
    <div style={{display:"flex",flexDirection:"column",height:"100%",background:"#f8fafc"}}>

      {/* Header */}
      <div style={{
        background:"white",borderBottom:"1px solid #e2e8f0",
        padding:"0 20px",height:52,display:"flex",alignItems:"center",gap:14,flexShrink:0
      }}>
        <button onClick={onBack} style={{
          background:"none",border:"none",cursor:"pointer",fontSize:20,color:"#64748b",
          display:"flex",alignItems:"center",lineHeight:1,padding:4,borderRadius:6,
          transition:"background .15s"
        }}
          onMouseEnter={e=>e.currentTarget.style.background="#f1f5f9"}
          onMouseLeave={e=>e.currentTarget.style.background="none"}
        >‹</button>
        <h2 style={{fontSize:17,fontWeight:700,color:"#0f172a",margin:0,flex:1}}>{form.name}</h2>
        <button style={{
          width:34,height:34,borderRadius:"50%",background:"#f59e0b",border:"none",
          cursor:"pointer",fontSize:16,display:"flex",alignItems:"center",justifyContent:"center",
          boxShadow:"0 2px 6px rgba(245,158,11,0.35)"
        }}>✏</button>
        <button style={{background:"none",border:"none",cursor:"pointer",fontSize:18,color:"#94a3b8"}}>⋯</button>
      </div>

      {/* Body */}
      <div style={{flex:1,overflowY:"auto",padding:"28px 32px"}}>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr 0.6fr",gap:40,maxWidth:1100}}>

          {/* ── Description ── */}
          <div>
            <div style={{fontSize:14,fontWeight:700,color:"#2563eb",marginBottom:18}}>Mô tả</div>

            <div style={rowStyle}>
              <span style={labelStyle}>Name</span>
              <input value={form.name} onChange={e=>set("name",e.target.value)} style={inputStyle}/>
            </div>

            <div style={rowStyle}>
              <span style={labelStyle}>Type</span>
              <div style={{position:"relative",flex:1}}>
                <select value={form.type} onChange={e=>set("type",e.target.value)} style={{...inputStyle,appearance:"none",paddingRight:28,cursor:"pointer"}}>
                  {ACTION_TYPES.map(t=><option key={t}>{t}</option>)}
                </select>
                <span style={{position:"absolute",right:10,top:"50%",transform:"translateY(-50%)",color:"#94a3b8",fontSize:11,pointerEvents:"none"}}>▾</span>
              </div>
            </div>

            <div style={rowStyle}>
              <span style={labelStyle}>Ưu tiên</span>
              <div style={{
                flex:1,border:"1px solid #e2e8f0",borderRadius:6,padding:"5px 10px",
                display:"flex",alignItems:"center",gap:8,background:"white",cursor:"pointer"
              }}>
                <span style={{color:"#ef4444",fontSize:12}}>↑</span>
                <span style={{fontSize:12,flex:1}}>{form.priority}</span>
                <span style={{fontSize:11,color:"#94a3b8"}}>✓</span>
              </div>
            </div>

            <div style={rowStyle}>
              <span style={labelStyle}>Mô tả</span>
              <textarea value={form.description} onChange={e=>set("description",e.target.value)}
                style={{...inputStyle,height:80,resize:"vertical"}}/>
            </div>

            <div style={rowStyle}>
              <span style={labelStyle}>Nhãn</span>
              <input value={form.labels} onChange={e=>set("labels",e.target.value)} style={inputStyle} placeholder="Thêm nhãn..."/>
            </div>
          </div>

          {/* ── Planning ── */}
          <div>
            <div style={{fontSize:14,fontWeight:700,color:"#2563eb",marginBottom:18}}>Kế hoạch</div>

            {/* Status selector */}
            <div style={rowStyle}>
              <span style={labelStyle}>Trạng thái</span>
              <div style={{display:"flex",alignItems:"center",gap:4}}>
                {STATUSES.map(s=>(
                  <button key={s} onClick={()=>set("status",s)} style={{
                    padding:"5px 10px",borderRadius:6,border:"none",cursor:"pointer",fontSize:11,fontWeight:600,
                    background:form.status===s
                      ? (s==="Cần làm"?"#2563eb":s==="Đang làm"?"#f59e0b":"#22c55e")
                      : "#f1f5f9",
                    color:form.status===s?"white":"#94a3b8",
                    transition:"all .15s"
                  }}>
                    {s==="Cần làm"?"Cần làm":s==="Đang làm"?"●":"●"}
                    {s!=="Cần làm"&&" "}
                  </button>
                ))}
              </div>
            </div>

            <div style={rowStyle}>
              <span style={labelStyle}>Người phụ trách</span>
              <input value={form.assignee} onChange={e=>set("assignee",e.target.value)} style={inputStyle}/>
            </div>

            {[
              ["Start date",       "startDate"],
              ["Hạn ban đầu...", "initialDeadline"],
              ["Hạn thực tế...",   "actualDeadline"],
            ].map(([label,key])=>(
              <div key={key} style={rowStyle}>
                <span style={labelStyle}>{label}</span>
                <div style={{flex:1,position:"relative"}}>
                  <input value={form[key]} onChange={e=>set(key,e.target.value)}
                    style={{...inputStyle,paddingLeft:30}} placeholder="dd/mm/yyyy"/>
                  <span style={{position:"absolute",left:9,top:"50%",transform:"translateY(-50%)",fontSize:13}}>📅</span>
                </div>
              </div>
            ))}

            {/* Budget achievements */}
            <div style={{fontSize:14,fontWeight:700,color:"#2563eb",margin:"20px 0 16px"}}>Đạt ngân sách</div>

            {[
              ["Chi phí (€)",          "cost",        "€"],
              ["Lợi ích dự kiến (€/năm)","expectedGain","€/yea"],
              ["Lợi ích thực tế (€/năm)", "actualGain",  "€/yea"],
            ].map(([label,key,unit])=>(
              <div key={key} style={rowStyle}>
                <span style={labelStyle}>{label}</span>
                <div style={{flex:1,position:"relative"}}>
                  <input value={form[key]} onChange={e=>set(key,e.target.value)}
                    style={{...inputStyle,paddingRight:36,textAlign:"right"}}/>
                  <span style={{position:"absolute",right:10,top:"50%",transform:"translateY(-50%)",fontSize:11,color:"#94a3b8"}}>{unit}</span>
                </div>
              </div>
            ))}
          </div>

          {/* ── Energy achievements ── */}
          <div>
            <div style={{fontSize:14,fontWeight:700,color:"#2563eb",marginBottom:18}}>Đạt tiết kiệm năng lượng</div>

            <div style={rowStyle}>
              <span style={labelStyle}>Impact on energy con...</span>
              <div style={{display:"flex",alignItems:"center",gap:10,paddingTop:6}}>
                <span style={{fontSize:12,color:"#94a3b8"}}>No</span>
                <button onClick={()=>set("energyImpact",!form.energyImpact)} style={{
                  width:38,height:20,borderRadius:10,border:"none",cursor:"pointer",position:"relative",
                  background:form.energyImpact?"#2563eb":"#cbd5e1",transition:"background .2s"
                }}>
                  <div style={{
                    width:14,height:14,borderRadius:"50%",background:"white",
                    position:"absolute",top:3,left:form.energyImpact?21:3,transition:"left .2s"
                  }}/>
                </button>
                <span style={{fontSize:12,color:"#94a3b8"}}>Yes</span>
              </div>
            </div>
          </div>

          {/* ── Right spacer / future attachments ── */}
          <div/>
        </div>
      </div>
    </div>
  )
}

// ─── Action Plan Kanban ───────────────────────────────────
function ActionPlanBoard({ siteId }) {
  const [onlyMine,       setOnlyMine]       = useState(false)
  const [activeTypes,    setActiveTypes]    = useState(new Set(ACTION_TYPES))
  const [dragging,       setDragging]       = useState(null)
  const [columns,        setColumns]        = useState(KANBAN_DATA)
  const [selectedCard,   setSelectedCard]   = useState(null)

  const toggleType = (t) => setActiveTypes(prev => {
    const n = new Set(prev)
    n.has(t) ? n.delete(t) : n.add(t)
    return n
  })
  const allSelected = activeTypes.size === ACTION_TYPES.length
  const toggleAll   = () => setActiveTypes(allSelected ? new Set() : new Set(ACTION_TYPES))

  const handleDragStart = (card, col) => setDragging({ card, col })
  const handleDrop = (targetCol) => {
    if (!dragging || dragging.col === targetCol) return
    setColumns(prev => {
      const next = {}
      Object.keys(prev).forEach(k => { next[k] = [...prev[k]] })
      next[dragging.col] = next[dragging.col].filter(c => c.id !== dragging.card.id)
      next[targetCol]    = [...next[targetCol], dragging.card]
      return next
    })
    setDragging(null)
  }

  if (selectedCard) {
    return <ActionTaskDetail card={selectedCard.card} colStatus={selectedCard.col} onBack={()=>setSelectedCard(null)}/>
  }

  return (
    <div style={{display:"flex",height:"100%",overflow:"hidden",background:"#f1f5f9"}}>

      {/* Left filter panel */}
      <div style={{width:190,background:"white",borderRight:"1px solid #e2e8f0",padding:"20px 16px",flexShrink:0,display:"flex",flexDirection:"column",gap:20}}>

        {/* Assignees */}
        <div>
          <div style={{fontSize:12,fontWeight:700,color:"#0f172a",marginBottom:10}}>Người phụ trách</div>
          {[{label:"Tất cả",val:false},{label:"Chỉ hành động của tôi",val:true}].map(o=>(
            <label key={o.label} style={{display:"flex",alignItems:"center",gap:8,fontSize:12,color:"#374151",cursor:"pointer",marginBottom:6}}>
              <input type="radio" checked={onlyMine===o.val} onChange={()=>setOnlyMine(o.val)}
                style={{accentColor:"#2563eb",cursor:"pointer"}}/>
              {o.label}
            </label>
          ))}
        </div>

        {/* Action types */}
        <div>
          <div style={{fontSize:12,fontWeight:700,color:"#0f172a",marginBottom:10}}>Loại hành động</div>
          <label style={{display:"flex",alignItems:"center",gap:8,fontSize:12,color:"#374151",cursor:"pointer",marginBottom:6}}>
            <input type="checkbox" checked={allSelected} onChange={toggleAll} style={{accentColor:"#2563eb",cursor:"pointer"}}/>
            Select all
          </label>
          {ACTION_TYPES.map(t=>(
            <label key={t} style={{display:"flex",alignItems:"center",gap:8,fontSize:12,color:"#374151",cursor:"pointer",marginBottom:6}}>
              <input type="checkbox" checked={activeTypes.has(t)} onChange={()=>toggleType(t)} style={{accentColor:TYPE_COLORS[t],cursor:"pointer"}}/>
              <span style={{display:"flex",alignItems:"center",gap:5}}>
                <span style={{width:10,height:10,background:TYPE_COLORS[t],borderRadius:2,display:"inline-block"}}/>
                {t}
              </span>
            </label>
          ))}
        </div>
      </div>

      {/* Kanban board */}
      <div style={{flex:1,overflowX:"auto",padding:"20px 16px",display:"flex",gap:16,alignItems:"flex-start"}}>

        {/* Header row: title + add button */}
        <div style={{position:"sticky",top:0,display:"contents"}}>
        </div>

        {Object.entries(columns).map(([status, cards])=>{
          const filtered = cards.filter(c => activeTypes.has(c.type))
          const sc = STATUS_COLORS[status]
          return (
            <div key={status}
              onDragOver={e=>e.preventDefault()}
              onDrop={()=>handleDrop(status)}
              style={{flex:1,minWidth:220,display:"flex",flexDirection:"column",gap:10}}
            >
              {/* Column header */}
              <div style={{
                display:"inline-flex",alignItems:"center",gap:6,
                background:sc.bg,color:sc.text,
                padding:"4px 12px",borderRadius:20,fontWeight:700,fontSize:12,
                alignSelf:"flex-start",marginBottom:4
              }}>
                {status} ({filtered.length})
              </div>

              {/* Cards */}
              <div style={{display:"flex",flexDirection:"column",gap:8,minHeight:120}}>
                {filtered.map(card=>(
                  <div key={card.id}
                    draggable
                    onDragStart={(e)=>{e.stopPropagation();handleDragStart(card,status)}}
                    onClick={()=>setSelectedCard({card, col:status})}
                    style={{
                      background:"white",borderRadius:8,padding:"12px 14px",
                      boxShadow:"0 1px 4px rgba(0,0,0,0.07)",
                      border:card.priority==="high"?"1px solid #fca5a5":"1px solid #f1f5f9",
                      cursor:"pointer",transition:"box-shadow .15s, transform .15s",
                    }}
                    onMouseEnter={e=>{e.currentTarget.style.boxShadow="0 4px 12px rgba(0,0,0,0.12)";e.currentTarget.style.transform="translateY(-1px)"}}
                    onMouseLeave={e=>{e.currentTarget.style.boxShadow="0 1px 4px rgba(0,0,0,0.07)";e.currentTarget.style.transform="translateY(0)"}}
                  >
                    {/* Title + date */}
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:8,gap:6}}>
                      <div style={{display:"flex",alignItems:"center",gap:6}}>
                        <span style={{
                          color:card.priority==="high"?"#ef4444":card.priority==="mid"?"#f59e0b":"#94a3b8",
                          fontSize:14,flexShrink:0
                        }}>
                          {card.priority==="high"?"↑":card.priority==="mid"?"↑":"≈"}
                        </span>
                        <span style={{fontSize:12,fontWeight:600,color:"#0f172a"}}>{card.title}</span>
                      </div>
                      {card.date&&<span style={{fontSize:9,color:"#ef4444",fontWeight:500,flexShrink:0,whiteSpace:"nowrap"}}>{card.date.slice(0,8)}</span>}
                    </div>

                    {/* Type tag + avatar */}
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                      <div style={{display:"flex",alignItems:"center",gap:5}}>
                        <div style={{width:10,height:10,background:TYPE_COLORS[card.type],borderRadius:2}}/>
                        <span style={{fontSize:11,color:"#64748b"}}>{card.type}</span>
                      </div>
                      <div style={{
                        width:26,height:26,borderRadius:"50%",background:"#1e3a5f",
                        display:"flex",alignItems:"center",justifyContent:"center",
                        fontSize:9,fontWeight:700,color:"white",flexShrink:0
                      }}>{card.user}</div>
                    </div>
                  </div>
                ))}

                {/* Drop zone hint when dragging */}
                {dragging && dragging.col !== status && (
                  <div style={{
                    border:"2px dashed #cbd5e1",borderRadius:8,height:60,
                    display:"flex",alignItems:"center",justifyContent:"center",
                    color:"#94a3b8",fontSize:11
                  }}>Thả vào đây</div>
                )}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

// ─── My Site — Metering Schematic ────────────────────────
const METER_DATA = {
  Water: {
    meters:[{ id:"W1", name:"General water", code:"2014", deliveryPoint:"2014", meterType:"Real",
      typeOfEntry:"Index", fluid:"Water", unit:"m³", co2:"", highThreshold:"", lowThreshold:"",
      pulseWeight:"", dataSource:"Automatic",
      sensors:[{id:"WS1",name:"Water consumption",sensorType:"Real",source:"manual",brand:"",
        module:"",channel:"1",identifier:"water_001",commission:"01/01/2016 à 00:00",
        uninstall:"",resolution:"60 minutes"}] }] },
  Electricity: {
    meters:[{ id:"E1", name:"General electricity", code:"2016", deliveryPoint:"2016", meterType:"Real",
      typeOfEntry:"Index", fluid:"Điện", unit:"kWh", co2:"", highThreshold:"", lowThreshold:"",
      pulseWeight:"", dataSource:"Automatic",
      sensors:[{id:"ES1",name:"Electricity consumption",sensorType:"Real",source:"enedis",brand:"enedis",
        module:"30001611429260",channel:"1",identifier:"enedis_30001611429260.1",commission:"01/01/2016 à 00:00",
        uninstall:"",resolution:"10 minutes"},
       {id:"ES2",name:"Load curve",sensorType:"Virtual",source:"enedis",brand:"enedis",
        module:"30001611429260",channel:"2",identifier:"enedis_lc_001",commission:"01/01/2016 à 00:00",
        uninstall:"",resolution:"30 minutes"}] }] },
  "Natural Gas":{
    meters:[{ id:"G1", name:"General gas", code:"2018", deliveryPoint:"2018", meterType:"Real",
      typeOfEntry:"Index", fluid:"Natural Gas", unit:"m³", co2:"", highThreshold:"", lowThreshold:"",
      pulseWeight:"", dataSource:"Automatic",
      sensors:[{id:"GS1",name:"Gas consumption",sensorType:"Real",source:"grdf",brand:"grdf",
        module:"GCU2019001",channel:"1",identifier:"grdf_001",commission:"01/06/2019 à 00:00",
        uninstall:"",resolution:"60 minutes"}] }] },
}
const FLUID_COLORS = { Water:"#2563eb", Electricity:"#22c55e", "Natural Gas":"#f59e0b" }
const FLUID_ICONS  = { Water:"💧", Electricity:"⚡", "Natural Gas":"🔥" }

// Mini SVG bar chart
function MiniBarChart({ color="#22c55e", count=24 }) {
  const heights = Array.from({length:count},()=>Math.random()*0.7+0.1)
  return (
    <svg viewBox={`0 0 ${count*5} 40`} style={{width:"100%",height:40}}>
      {heights.map((h,i)=>(
        <rect key={i} x={i*5} y={40-h*38} width={3.5} height={h*38} fill={color} rx={1} opacity={0.85}/>
      ))}
    </svg>
  )
}

// Monotonic / distribution chart
function MonotonicChart() {
  const pts = Array.from({length:30},(_, i)=>{
    const x = (i/29)*90 + 5
    const y = 5 + Math.pow(1-(i/29),1.8)*70
    return `${x},${y}`
  }).join(" ")
  return (
    <svg viewBox="0 0 100 80" style={{width:"100%",height:80}}>
      <line x1={5} y1={75} x2={95} y2={75} stroke="#e2e8f0" strokeWidth={0.5}/>
      <line x1={5} y1={5}  x2={5}  y2={75} stroke="#e2e8f0" strokeWidth={0.5}/>
      {[0,25,50,75,100].map(v=>(
        <text key={v} x={5+(v/100)*90} y={79} textAnchor="middle" fontSize={5} fill="#94a3b8">{v}</text>
      ))}
      {[0,5,10,15].map((v,i)=>(
        <text key={v} x={3} y={75-i*(70/3)} textAnchor="end" fontSize={5} fill="#94a3b8">{v}</text>
      ))}
      <polyline points={pts} fill="none" stroke="#22c55e" strokeWidth={1.5}/>
      <polygon points={`5,75 ${pts} 95,75`} fill="#22c55e" opacity={0.15}/>
    </svg>
  )
}

// Aggregation-aware bar chart
function AggBarChart({ aggr, color="#22c55e" }) {
  // Generate data that visually changes with aggregation
  const configs = {
    None:    { count:56, maxH:0.35, label:(i)=>"" },
    Hourly:  { count:24, maxH:0.55, label:(i)=>i%6===0?`${i}h`:"" },
    Daily:   { count:7,  maxH:0.85, label:(i)=>["Mon","Tue","Wed","Thu","Fri","Sat","Sun"][i] },
    Weekly:  { count:2,  maxH:0.95, label:(i)=>`W${21+i}/24` },
    Monthly: { count:12, maxH:1.0,  label:(i)=>["J","F","M","A","M","J","J","A","S","O","N","D"][i] },
  }
  const cfg   = configs[aggr] || configs["None"]
  // Deterministic heights per aggregation using index-based formula
  const seed  = aggr.charCodeAt(0)
  const heights = Array.from({length:cfg.count},(_, i)=>{
    const base = ((Math.sin(i*seed*0.7+1.3)*0.5+0.5))
    return Math.max(0.05, base * cfg.maxH)
  })
  const H = 100
  const maxH = Math.max(...heights)
  return (
    <div style={{paddingLeft:28,position:"relative"}}>
      {/* Y axis labels */}
      {[0,0.25,0.5,0.75,1.0].map((f,i)=>(
        <div key={i} style={{
          position:"absolute",left:0,top:`${(1-f)*H}px`,
          fontSize:8,color:"#94a3b8",lineHeight:1,transform:"translateY(-50%)"
        }}>{aggr==="None"?"":Math.round(f*150)}</div>
      ))}
      <div style={{display:"flex",alignItems:"flex-end",gap:cfg.count>20?1:4,height:H,borderBottom:"1px solid #e2e8f0",overflow:"hidden"}}>
        {heights.map((h,i)=>(
          <div key={i} style={{
            flex:1,minWidth:cfg.count>20?2:8,
            height:`${(h/maxH)*100}%`,
            background:color,borderRadius:"2px 2px 0 0",opacity:0.85,
            transition:"height .3s ease"
          }}/>
        ))}
      </div>
      {/* X labels */}
      <div style={{display:"flex",marginTop:3,overflow:"hidden"}}>
        {heights.map((_,i)=>(
          <div key={i} style={{flex:1,fontSize:7,color:"#94a3b8",textAlign:"center",minWidth:0,overflow:"hidden",textOverflow:"clip"}}>
            {cfg.label(i)}
          </div>
        ))}
      </div>
    </div>
  )
}

// Custom dropdown for aggregation
function AggrDropdown({ value, onChange, options }) {
  const [open, setOpen] = useState(false)
  return (
    <div style={{position:"relative"}} onClick={e=>e.stopPropagation()}>
      <button onClick={()=>setOpen(o=>!o)} style={{
        display:"flex",alignItems:"center",gap:6,
        border:"1px solid #e2e8f0",borderRadius:6,padding:"4px 10px",
        background:"white",cursor:"pointer",fontSize:11,fontWeight:500,color:"#374151",
        minWidth:80,justifyContent:"space-between"
      }}>
        {value}
        <span style={{color:"#94a3b8",fontSize:10}}>▾</span>
      </button>
      {open && (
        <div style={{
          position:"absolute",top:"calc(100% + 4px)",right:0,
          background:"white",border:"1px solid #e2e8f0",borderRadius:8,
          boxShadow:"0 8px 24px rgba(0,0,0,0.12)",zIndex:300,minWidth:110,overflow:"hidden"
        }}>
          {options.map(opt=>(
            <div key={opt} onClick={()=>{onChange(opt);setOpen(false)}} style={{
              padding:"8px 14px",fontSize:12,cursor:"pointer",
              background:opt===value?"#eff6ff":"white",
              color:opt===value?"#2563eb":"#374151",
              fontWeight:opt===value?600:400,
              transition:"background .1s"
            }}
              onMouseEnter={e=>{if(opt!==value)e.currentTarget.style.background="#f8fafc"}}
              onMouseLeave={e=>{if(opt!==value)e.currentTarget.style.background="white"}}
            >{opt}</div>
          ))}
        </div>
      )}
    </div>
  )
}

const AGGR_OPTIONS = ["None","Hourly","Daily","Weekly","Monthly"]

// Sensor Detail Modal
function SensorModal({ sensor, meter, onClose }) {
  const [aggrWeek, setAggrWeek]     = useState("Weekly")
  const [aggrHist, setAggrHist]     = useState("Monthly")

  const histMonths = ["Jul","Aug","Sep","Oct","Nov","Dec","Jan","Feb","Mar","Apr","May"]
  const histSeed   = 42
  const histH = Array.from({length:11},(_, i)=>{
    const base = aggrHist==="Monthly"
      ? [0.55,0.62,0.7,0.82,0.9,0.75,0.48,0.42,0.35,0.25,0.15][i]
      : aggrHist==="Weekly"
        ? Math.abs(Math.sin(i*0.9+1))*0.8+0.1
        : Math.abs(Math.sin(i*2.1+0.5))*0.5+0.05
    return base
  })
  const maxHist = Math.max(...histH)

  return (
    <div style={{
      position:"fixed",inset:0,background:"rgba(0,0,0,0.35)",
      display:"flex",alignItems:"flex-start",justifyContent:"center",
      paddingTop:60,zIndex:2000
    }} onClick={e=>{if(e.target===e.currentTarget)onClose()}}>
      <div style={{
        background:"white",borderRadius:10,width:860,maxHeight:"82vh",overflow:"auto",
        boxShadow:"0 20px 60px rgba(0,0,0,0.25)"
      }}>
        {/* Header */}
        <div style={{
          padding:"12px 20px",borderBottom:"1px solid #e2e8f0",
          display:"flex",alignItems:"center",justifyContent:"space-between",position:"sticky",top:0,background:"white",zIndex:10
        }}>
          <div style={{display:"flex",alignItems:"center",gap:8,flexWrap:"wrap"}}>
            <span style={{fontSize:11,color:"#64748b",fontWeight:500}}>
              {sensor.identifier?.toUpperCase()} ·
            </span>
            <span style={{fontSize:13,fontWeight:700,color:"#0f172a"}}>{sensor.name.toUpperCase()}</span>
            <span style={{fontSize:11,color:"#94a3b8",marginLeft:4}}>
              Installation: {sensor.commission?.split(" ")[0]} - Uninstallation →
            </span>
          </div>
          <button onClick={onClose} style={{
            background:"none",border:"none",cursor:"pointer",fontSize:20,color:"#64748b",
            lineHeight:1,padding:4,borderRadius:6,flexShrink:0
          }}>×</button>
        </div>

        {/* 2×2 grid */}
        <div style={{padding:20,display:"grid",gridTemplateColumns:"1fr 1fr",gap:16}}>

          {/* ── Global indicators ── */}
          <div style={{background:"#f8fafc",borderRadius:8,padding:16}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
              <span style={{fontSize:12,fontWeight:600,color:"#64748b"}}>Chỉ số tổng quan</span>
              <span style={{fontSize:10,color:"#64748b"}}>📅 06/06/2023 · 06/06/2024</span>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:8,marginBottom:16}}>
              {[
                {l:"Minimum",  v:"0",        u:"kWh", accent:false},
                {l:"Maximum",  v:"10.04",    u:"kWh", accent:true},
                {l:"Average",  v:"—",        u:"kWh", accent:false},
                {l:"Sum",      v:"17 840.91",u:"kWh", accent:true},
              ].map(s=>(
                <div key={s.l} style={{textAlign:"center"}}>
                  <div style={{fontSize:10,color:"#64748b",marginBottom:4}}>{s.l}</div>
                  <div style={{fontSize:14,fontWeight:800,color:s.accent?"#22c55e":"#0f172a"}}>{s.v}</div>
                  <div style={{fontSize:9,color:"#94a3b8"}}>{s.u}</div>
                </div>
              ))}
            </div>
            <div style={{borderTop:"1px solid #e2e8f0",paddingTop:12}}>
              <div style={{display:"grid",gridTemplateColumns:"1fr auto auto",gap:8,fontSize:11,marginBottom:4}}>
                <span style={{color:"#64748b",fontWeight:600}}>Threshold exceedances</span>
                <span style={{color:"#64748b",textAlign:"right"}}>Tổng</span>
                <span style={{color:"#64748b",textAlign:"right",minWidth:32}}>Time</span>
              </div>
              {["High threshold","Low threshold"].map(t=>(
                <div key={t} style={{display:"grid",gridTemplateColumns:"1fr auto auto",gap:8,marginBottom:3}}>
                  <span style={{fontSize:10,color:"#374151"}}>{t} —</span>
                  <span style={{fontSize:10,color:"#94a3b8",textAlign:"right"}}>—</span>
                  <span style={{fontSize:10,color:"#94a3b8",textAlign:"right",minWidth:32}}>—%</span>
                </div>
              ))}
            </div>
          </div>

          {/* ── Current week ── */}
          <div style={{background:"#f8fafc",borderRadius:8,padding:16}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
              <span style={{fontSize:12,fontWeight:600,color:"#64748b"}}>Tuần hiện tại</span>
              <div style={{display:"flex",gap:8,alignItems:"center"}}>
                <span style={{fontSize:10,color:"#64748b"}}>📅 24/05/2024 - 30/05/2024</span>
                <AggrDropdown value={aggrWeek} onChange={setAggrWeek} options={AGGR_OPTIONS}/>
                <button style={{background:"none",border:"none",cursor:"pointer",color:"#94a3b8",fontSize:14}}>⋯</button>
              </div>
            </div>
            <div style={{position:"relative",paddingLeft:4}}>
              <button style={{position:"absolute",left:-8,top:"40%",background:"none",border:"none",cursor:"pointer",fontSize:18,color:"#94a3b8",zIndex:1}}>‹</button>
              <AggBarChart aggr={aggrWeek} color="#22c55e"/>
              <button style={{position:"absolute",right:-8,top:"40%",background:"none",border:"none",cursor:"pointer",fontSize:18,color:"#94a3b8",zIndex:1}}>›</button>
            </div>
          </div>

          {/* ── Monotonic chart ── */}
          <div style={{background:"#f8fafc",borderRadius:8,padding:16}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
              <span style={{fontSize:12,fontWeight:600,color:"#64748b"}}>Biểu đồ đơn điệu</span>
              <span style={{fontSize:10,color:"#64748b"}}>📅 06/06/2023 · 06/06/2024</span>
            </div>
            <MonotonicChart/>
            <div style={{fontSize:9,color:"#94a3b8",textAlign:"center",marginTop:4}}>Percentage (%)</div>
          </div>

          {/* ── Data history ── */}
          <div style={{background:"#f8fafc",borderRadius:8,padding:16}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
              <span style={{fontSize:12,fontWeight:600,color:"#64748b"}}>Lịch sử dữ liệu</span>
              <div style={{display:"flex",gap:8,alignItems:"center"}}>
                <span style={{fontSize:10,color:"#64748b"}}>📅 04/06/2022 · 05/06/2023</span>
                <AggrDropdown value={aggrHist} onChange={setAggrHist} options={["Daily","Weekly","Monthly"]}/>
                <button style={{background:"none",border:"none",cursor:"pointer",color:"#94a3b8",fontSize:14}}>⋯</button>
              </div>
            </div>
            <div style={{position:"relative"}}>
              <div style={{paddingLeft:28,position:"relative"}}>
                {/* Y axis */}
                {[0,5,10,15,20,25].map((v,i)=>(
                  <div key={v} style={{
                    position:"absolute",left:0,
                    bottom:`${(v/25)*80}px`,
                    fontSize:8,color:"#94a3b8",lineHeight:1
                  }}>{v>0?`${v}k`:""}</div>
                ))}
                <div style={{display:"flex",alignItems:"flex-end",gap:aggrHist==="Daily"?1:4,height:80,borderBottom:"1px solid #e2e8f0"}}>
                  {histH.map((h,i)=>(
                    <div key={i} style={{
                      flex:1,minWidth:aggrHist==="Daily"?2:6,
                      height:`${(h/maxHist)*100}%`,
                      background:"#22c55e",borderRadius:"2px 2px 0 0",opacity:0.85,
                      transition:"height .4s ease"
                    }}/>
                  ))}
                </div>
                <div style={{display:"flex",gap:0,marginTop:3}}>
                  {histMonths.map((m,i)=>(
                    <div key={i} style={{flex:1,fontSize:7,color:"#94a3b8",textAlign:"center"}}>{m}</div>
                  ))}
                </div>
              </div>
              <button style={{position:"absolute",right:-8,top:"40%",background:"none",border:"none",cursor:"pointer",fontSize:18,color:"#94a3b8"}}>›</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

// Meter icon SVG
function MeterIcon({ color="#22c55e", active=false }) {
  return (
    <svg viewBox="0 0 60 30" style={{width:70,height:35}}>
      <line x1={2} y1={15} x2={20} y2={15} stroke="#94a3b8" strokeWidth={1.5}/>
      <rect x={20} y={6} width={20} height={18} rx={3} fill="white" stroke={active?color:"#cbd5e1"} strokeWidth={1.5}/>
      <circle cx={30} cy={15} r={4} fill={active?color:"#e2e8f0"}/>
      {active&&<circle cx={30} cy={15} r={2} fill="white"/>}
      <line x1={40} y1={15} x2={58} y2={15} stroke="#94a3b8" strokeWidth={1.5}/>
      <polygon points="55,12 60,15 55,18" fill="#94a3b8"/>
    </svg>
  )
}

// ─── Sensors Panel ───────────────────────────────────────
const SENSORS_DATA = {
  "Hệ thống đo lường": [
    { category:"Điện", sensors:[
      { id:"ES1", identifier:"enedis_30001611429260.1", name:"Load curve",             fluid:"Điện", sensorType:"Real", source:"enedis",     brand:"enedis",     module:"30001611429260", channel:"2", commission:"01/01/2016 à 00:00", resolution:"30 minutes", uninstall:"", chartType:"bar" },
      { id:"ES2", identifier:"enedis_30001611429260.1", name:"Electricity consumption",fluid:"Điện", sensorType:"Real", source:"enedis",     brand:"enedis",     module:"30001611429260", channel:"1", commission:"01/01/2016 à 00:00", resolution:"10 minutes", uninstall:"", chartType:"bar" },
    ]},
    { category:"Natural Gas", sensors:[
      { id:"GS1", identifier:"grdf_04334008650500.8",   name:"Gas volume",             fluid:"Natural Gas", sensorType:"Real", source:"grdf",       brand:"grdf",       module:"04334008650500", channel:"8", commission:"01/01/2016 à 00:00", resolution:"Daily",      uninstall:"", chartType:"bar" },
      { id:"GS2", identifier:"grdf_04334008650500.7",   name:"Gas consumption",        fluid:"Natural Gas", sensorType:"Real", source:"grdf",       brand:"grdf",       module:"04334008650500", channel:"7", commission:"01/01/2016 à 00:00", resolution:"Daily",      uninstall:"", chartType:"bar" },
    ]},
  ],
  "Yếu tố ảnh hưởng": [
    { category:"Temperature", sensors:[
      { id:"TS1", identifier:"weatherbit_076490-99999.1", name:"Outside temperature", fluid:"Temperature", sensorType:"Real", source:"weatherbit", brand:"weatherbit", module:"076490-99999", channel:"1", commission:"01/01/2016 à 00:00", resolution:"1 hour", uninstall:"", chartType:"heatmap" },
    ]},
    { category:"Hygrometry", sensors:[
      { id:"HS1", identifier:"weatherbit_076490-99999.6", name:"Outside humidity",    fluid:"Hygrometry",  sensorType:"Real", source:"weatherbit", brand:"weatherbit", module:"076490-99999", channel:"6", commission:"01/01/2016 à 00:00", resolution:"1 hour", uninstall:"", chartType:"line" },
    ]},
    { category:"Other", sensors:Array.from({length:6},(_,i)=>({
      id:`OT${i+1}`, identifier:`other_sensor_00${i+1}`, name:`Other sensor ${i+1}`, fluid:"Other",
      sensorType:"Virtual", source:"manual", brand:"", module:"", channel:`${i+1}`,
      commission:"01/01/2020 à 00:00", resolution:"60 minutes", uninstall:"", chartType:"bar"
    }))},
  ],
  "Thay đổi trạng thái": [],
}

function SensorMiniLine({ color="#22c55e" }) {
  const pts = Array.from({length:40},(_,i)=>{
    const y = 40 - (Math.sin(i*0.4)*12 + Math.sin(i*0.15)*8 + 20)
    return `${i*5},${y}`
  }).join(" ")
  return (
    <svg viewBox="0 0 200 50" style={{width:"100%",height:50}}>
      <polyline points={pts} fill="none" stroke={color} strokeWidth={1.5}/>
    </svg>
  )
}

function SensorHeatmap() {
  const rows=4, cols=7
  const colors=["#e8f5e9","#c8e6c9","#a5d6a7","#66bb6a","#43a047","#2e7d32"]
  return (
    <div style={{display:"grid",gridTemplateColumns:`repeat(${cols},1fr)`,gap:2,padding:"4px 0"}}>
      {Array.from({length:rows*cols},(_,i)=>{
        const v = Math.floor(Math.abs(Math.sin(i*1.3+0.5))*colors.length)
        return <div key={i} style={{height:14,background:colors[Math.min(v,colors.length-1)],borderRadius:2}}/>
      })}
    </div>
  )
}

function SensorsPanel() {
  const [filterTab,       setFilterTab]     = useState("Xem tất cả")
  const [expandedCats,    setExpandedCats]  = useState({})  // key: "column|category"
  const [selectedSensor,  setSelectedSensor]= useState(null)

  const totalCounts = {
    "Hệ thống đo lường": SENSORS_DATA["Hệ thống đo lường"].reduce((a,c)=>a+c.sensors.length,0),
    "Yếu tố ảnh hưởng": SENSORS_DATA["Yếu tố ảnh hưởng"].reduce((a,c)=>a+c.sensors.length,0),
    "Thay đổi trạng thái": 0,
  }

  const toggleCat = (col, cat) => {
    const key = `${col}|${cat}`
    setExpandedCats(prev=>({...prev,[key]:!prev[key]}))
  }
  const isExpanded = (col, cat) => !!expandedCats[`${col}|${cat}`]

  const FLUID_COLOR = { Electricity:"#2563eb", "Natural Gas":"#f59e0b", Temperature:"#2563eb", Hygrometry:"#2563eb", Other:"#2563eb" }

  return (
    <div style={{flex:1,display:"flex",overflow:"hidden"}}>
      <div style={{flex:1,display:"flex",flexDirection:"column",overflow:"hidden"}}>

        {/* Filter row */}
        <div style={{
          background:"white",borderBottom:"1px solid #e2e8f0",
          padding:"0 16px",display:"flex",alignItems:"center",justifyContent:"space-between",flexShrink:0
        }}>
          <div style={{display:"flex",gap:0}}>
            {["Xem tất cả","Đã cài","Chưa cài"].map(t=>(
              <button key={t} onClick={()=>setFilterTab(t)} style={{
                display:"flex",alignItems:"center",gap:5,
                padding:"10px 14px",border:"none",cursor:"pointer",fontSize:12,fontWeight:500,
                background:"transparent",color:filterTab===t?"#2563eb":"#64748b",
                borderBottom:filterTab===t?"2px solid #2563eb":"2px solid transparent",transition:"all .15s"
              }}>
                {t!=="Xem tất cả" && (
                  <div style={{width:8,height:8,borderRadius:"50%",background:t==="Đã cài"?"#22c55e":"#94a3b8",flexShrink:0}}/>
                )}
                {t}
              </button>
            ))}
          </div>
          <div style={{display:"flex",alignItems:"center",gap:8}}>
            {/* List/Grid toggle */}
            <button style={{background:"none",border:"none",cursor:"pointer",color:"#94a3b8",fontSize:16}}>≡</button>
            <button style={{background:"none",border:"none",cursor:"pointer",color:"#64748b",fontSize:14}}>⊞</button>
            {/* Add */}
            <button style={{
              width:28,height:28,borderRadius:"50%",background:"#22c55e",border:"none",
              cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",
              color:"white",fontSize:18,fontWeight:300,boxShadow:"0 2px 8px rgba(34,197,94,.35)"
            }}>+</button>
            <button style={{background:"none",border:"none",cursor:"pointer",color:"#94a3b8",fontSize:16}}>⋯</button>
          </div>
        </div>

        {/* 3 columns */}
        <div style={{flex:1,display:"flex",gap:0,overflow:"auto",padding:"16px 12px",background:"#f8fafc"}}>
          {Object.entries(SENSORS_DATA).map(([colName, cats])=>(
            <div key={colName} style={{flex:1,minWidth:220,marginRight:12,display:"flex",flexDirection:"column",gap:0}}>
              {/* Column header */}
              <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:10}}>
                <span style={{fontSize:12,fontWeight:600,color:"#374151"}}>{colName} ({totalCounts[colName]})</span>
                <div style={{flex:1,height:1,background:"#e2e8f0"}}/>
                <button style={{background:"none",border:"none",cursor:"pointer",fontSize:18,color:"#94a3b8",lineHeight:1}}>—</button>
              </div>

              {/* Category cards */}
              <div style={{background:"white",border:"1px solid #e2e8f0",borderRadius:8,overflow:"hidden"}}>
                {cats.length===0 ? (
                  <div style={{padding:"24px 12px",color:"#e2e8f0",fontSize:12,textAlign:"center"}}>—</div>
                ) : cats.map((cat, ci)=>{
                  const expanded = isExpanded(colName, cat.category)
                  return (
                    <div key={cat.category} style={{borderBottom: ci<cats.length-1?"1px solid #f1f5f9":"none"}}>
                      {/* Category row */}
                      <div
                        onClick={()=>toggleCat(colName, cat.category)}
                        style={{
                          display:"flex",alignItems:"center",justifyContent:"space-between",
                          padding:"12px 14px",cursor:"pointer",
                          background: expanded?"#f0f7ff":"white",
                          transition:"background .15s"
                        }}
                        onMouseEnter={e=>{if(!expanded)e.currentTarget.style.background="#f8fafc"}}
                        onMouseLeave={e=>{if(!expanded)e.currentTarget.style.background="white"}}
                      >
                        <span style={{fontSize:12,color:FLUID_COLOR[cat.category]||"#2563eb",fontWeight:500}}>
                          {cat.category}
                        </span>
                        <div style={{display:"flex",alignItems:"center",gap:6}}>
                          <span style={{fontSize:10,color:"#94a3b8"}}>🗃 {cat.sensors.length}</span>
                        </div>
                      </div>

                      {/* Expanded sensor rows */}
                      {expanded && cat.sensors.map(sensor=>{
                        const isSel = selectedSensor?.id===sensor.id
                        return (
                          <div key={sensor.id}
                            onClick={()=>setSelectedSensor(isSel?null:sensor)}
                            style={{
                              display:"flex",alignItems:"center",gap:10,
                              padding:"9px 14px 9px 18px",cursor:"pointer",
                              background:isSel?"#2563eb":"#f8fafc",
                              borderTop:"1px solid #e8f0fe",
                              transition:"background .15s"
                            }}
                            onMouseEnter={e=>{if(!isSel)e.currentTarget.style.background="#eff6ff"}}
                            onMouseLeave={e=>{if(!isSel)e.currentTarget.style.background="#f8fafc"}}
                          >
                            <div style={{width:9,height:9,borderRadius:"50%",background:"#22c55e",border:"2px solid white",flexShrink:0}}/>
                            <div style={{flex:1,minWidth:0}}>
                              <div style={{fontSize:9,color:isSel?"rgba(255,255,255,0.7)":"#94a3b8",fontFamily:"monospace",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>
                                {sensor.identifier}
                              </div>
                              <div style={{fontSize:11,fontWeight:600,color:isSel?"white":"#0f172a",marginTop:1}}>{sensor.name}</div>
                            </div>
                            <div style={{fontSize:10,color:isSel?"rgba(255,255,255,0.7)":"#94a3b8",flexShrink:0}}>{sensor.fluid}</div>
                          </div>
                        )
                      })}
                    </div>
                  )
                })}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Right detail panel */}
      <div style={{
        width:260,background:"white",borderLeft:"1px solid #e2e8f0",
        display:"flex",flexDirection:"column",flexShrink:0,overflow:"auto"
      }}>
        {!selectedSensor ? (
          <div style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:8,padding:24,textAlign:"center"}}>
            <span style={{fontSize:13,color:"#94a3b8",fontWeight:500}}>Chưa chọn đối tượng</span>
            <span style={{fontSize:11,color:"#cbd5e1"}}>Hãy chọn một đối tượng để xem thông tin</span>
          </div>
        ) : (
          <div>
            {/* Header */}
            <div style={{padding:"10px 14px",borderBottom:"1px solid #f1f5f9",background:"#f8fafc",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
              <div>
                <span style={{fontSize:10,color:"#64748b"}}>Sensor · </span>
                <span style={{fontSize:12,fontWeight:700,color:"#0f172a"}}>{selectedSensor.name}</span>
              </div>
              <button style={{background:"none",border:"none",cursor:"pointer",color:"#94a3b8",fontSize:16}}>⋯</button>
            </div>

            {/* Tabs */}
            <div style={{display:"flex",borderBottom:"1px solid #f1f5f9"}}>
              {["Thông tin","Cảnh báo"].map((t,i)=>(
                <button key={t} style={{
                  padding:"8px 14px",background:"none",border:"none",cursor:"pointer",fontSize:12,fontWeight:700,
                  color:i===0?"#2563eb":"#94a3b8",borderBottom:i===0?"2px solid #2563eb":"2px solid transparent"
                }}>{t}</button>
              ))}
            </div>

            {/* Edit icon */}
            <div style={{display:"flex",justifyContent:"flex-end",padding:"6px 14px 0"}}>
              <div style={{
                width:26,height:26,borderRadius:"50%",background:"#f59e0b",display:"flex",
                alignItems:"center",justifyContent:"center",cursor:"pointer",fontSize:12
              }}>✏</div>
            </div>

            {/* Fields */}
            {[
              ["Name",                selectedSensor.name],
              ["Sensor type",         selectedSensor.sensorType],
              ["Source",              selectedSensor.source],
              ["Brand",               selectedSensor.brand],
              ["Template",            ""],
              ["Module",              selectedSensor.module],
              ["Channel used",        selectedSensor.channel],
              ["Identifier",          selectedSensor.identifier],
              ["Date of commission...",selectedSensor.commission],
              ["Uninstallation date", selectedSensor.uninstall||"—"],
              ["Time resolution",     selectedSensor.resolution],
            ].map(([k,v])=>(
              <div key={k} style={{
                display:"flex",justifyContent:"space-between",alignItems:"flex-start",
                padding:"5px 14px",borderBottom:"1px solid #f8fafc",gap:8
              }}>
                <span style={{fontSize:11,color:"#64748b",flexShrink:0}}>{k}</span>
                <span style={{fontSize:10,fontWeight:600,color:"#0f172a",textAlign:"right",wordBreak:"break-all"}}>{v||"—"}</span>
              </div>
            ))}

            {/* LAST WEEK chart */}
            <div style={{padding:"8px 14px 0",background:"#f8fafc",fontSize:10,fontWeight:700,color:"#94a3b8",letterSpacing:1,marginTop:6}}>
              LAST WEEK
            </div>
            <div style={{padding:"6px 14px 12px"}}>
              {selectedSensor.chartType==="line"
                ? <SensorMiniLine color="#2563eb"/>
                : selectedSensor.chartType==="heatmap"
                  ? <SensorHeatmap/>
                  : <MiniBarChart color="#22c55e" count={18}/>
              }
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

// ─── Reusable form field helpers ─────────────────────────
function FField({ label, value="", onChange, disabled=false, placeholder="" }) {
  return (
    <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:10}}>
      <span style={{fontSize:11,color:"#64748b",width:130,flexShrink:0,textAlign:"right"}}>{label}</span>
      <input value={value} onChange={onChange} disabled={disabled} placeholder={placeholder}
        style={{
          flex:1,border:"1px solid #e2e8f0",borderRadius:5,padding:"5px 9px",fontSize:12,
          background:disabled?"#f8fafc":"white",color:disabled?"#94a3b8":"#0f172a",outline:"none"
        }}
      />
    </div>
  )
}
function FSelect({ label, value, onChange, options=[] }) {
  return (
    <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:10}}>
      <span style={{fontSize:11,color:"#64748b",width:130,flexShrink:0,textAlign:"right"}}>{label}</span>
      <div style={{flex:1,position:"relative"}}>
        <select value={value} onChange={onChange} style={{
          width:"100%",border:"1px solid #e2e8f0",borderRadius:5,padding:"5px 28px 5px 9px",
          fontSize:12,background:"white",color:"#0f172a",outline:"none",appearance:"none",cursor:"pointer"
        }}>
          {options.map(o=><option key={o}>{o}</option>)}
        </select>
        <span style={{position:"absolute",right:9,top:"50%",transform:"translateY(-50%)",fontSize:10,color:"#94a3b8",pointerEvents:"none"}}>▾</span>
      </div>
    </div>
  )
}
function FSectionTitle({ children }) {
  return <div style={{fontSize:13,fontWeight:700,color:"#2563eb",margin:"18px 0 12px"}}>{children}</div>
}
function FSubtitle({ children }) {
  return <div style={{fontSize:12,fontWeight:700,color:"#374151",margin:"14px 0 8px"}}>{children}</div>
}
function FRow2({ children }) {
  return <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>{children}</div>
}
function FTextarea({ label, value="", onChange }) {
  return (
    <div style={{display:"flex",alignItems:"flex-start",gap:8,marginBottom:10}}>
      <span style={{fontSize:11,color:"#64748b",width:130,flexShrink:0,textAlign:"right",paddingTop:5}}>{label}</span>
      <textarea value={value} onChange={onChange} rows={4}
        style={{flex:1,border:"1px solid #e2e8f0",borderRadius:5,padding:"5px 9px",fontSize:12,resize:"vertical",outline:"none"}}
      />
    </div>
  )
}

// ─── Synoptic Panel ──────────────────────────────────────

// SVG energy flow node (meter box)
function FlowNode({ color="#22c55e", label="", hasAlert=false, size=36, onClick }) {
  return (
    <div onClick={onClick} style={{
      position:"relative",display:"inline-flex",flexDirection:"column",
      alignItems:"center",gap:3,cursor:onClick?"pointer":"default"
    }}>
      <svg viewBox="0 0 40 24" style={{width:size*1.6,height:size}}>
        <rect x={2} y={4} width={16} height={16} rx={3} fill="white" stroke={color} strokeWidth={1.5}/>
        <circle cx={10} cy={12} r={4} fill={color} opacity={0.25}/>
        <circle cx={10} cy={12} r={2} fill={color}/>
        <line x1={18} y1={12} x2={24} y2={12} stroke={color} strokeWidth={1.5}/>
        <rect x={24} y={4} width={14} height={16} rx={3} fill="white" stroke={color} strokeWidth={1.5}/>
        <circle cx={31} cy={12} r={3} fill={color} opacity={0.2}/>
        <line x1={26} y1={9} x2={36} y2={9} stroke={color} strokeWidth={1} opacity={0.4}/>
        <line x1={26} y1={12} x2={36} y2={12} stroke={color} strokeWidth={1} opacity={0.4}/>
        <line x1={26} y1={15} x2={36} y2={15} stroke={color} strokeWidth={1} opacity={0.4}/>
      </svg>
      {hasAlert && (
        <div style={{
          position:"absolute",top:-6,right:-6,
          width:18,height:18,borderRadius:"50%",
          background:"#ef4444",display:"flex",alignItems:"center",justifyContent:"center",
          boxShadow:"0 2px 6px rgba(239,68,68,.4)",zIndex:2
        }}>
          <span style={{fontSize:9,color:"white",fontWeight:900}}>!</span>
        </div>
      )}
      {label && <span style={{fontSize:9,color:"#64748b",textAlign:"center",maxWidth:70}}>{label}</span>}
    </div>
  )
}

// Gear/transformer box
function TransformBox({ label="", subItems=[], expanded=false, onToggle }) {
  return (
    <div style={{
      border:"1px solid #e2e8f0",borderRadius:8,background:"#f8fafc",
      minWidth:160,overflow:"hidden"
    }}>
      <div onClick={onToggle} style={{
        display:"flex",alignItems:"center",gap:8,padding:"10px 12px",cursor:"pointer",
        background:"white",borderBottom:expanded&&subItems.length?"1px solid #e2e8f0":"none"
      }}>
        <svg viewBox="0 0 20 20" style={{width:20,height:20,flexShrink:0}}>
          <circle cx={10} cy={10} r={8} fill="#f1f5f9" stroke="#94a3b8" strokeWidth={1.5}/>
          <circle cx={10} cy={10} r={3} fill="#94a3b8"/>
          {[0,60,120,180,240,300].map(a=>{
            const rad=a*Math.PI/180
            const x1=10+5.5*Math.cos(rad), y1=10+5.5*Math.sin(rad)
            const x2=10+7.5*Math.cos(rad), y2=10+7.5*Math.sin(rad)
            return <line key={a} x1={x1} y1={y1} x2={x2} y2={y2} stroke="#94a3b8" strokeWidth={1.5} strokeLinecap="round"/>
          })}
        </svg>
        <span style={{fontSize:11,fontWeight:600,color:"#374151",flex:1}}>{label}</span>
        {subItems.length>0&&<span style={{fontSize:10,color:"#94a3b8"}}>{expanded?"▲":"▼"}</span>}
      </div>
      {expanded && subItems.map((item,i)=>(
        <div key={i} style={{
          display:"flex",alignItems:"center",justifyContent:"space-between",
          padding:"7px 12px 7px 20px",borderBottom:"1px solid #f1f5f9",
          fontSize:11,color:"#374151",background:"white"
        }}>
          <span>{item}</span>
          <div style={{display:"flex",gap:4,alignItems:"center"}}>
            <span style={{fontSize:10,color:"#94a3b8"}}>◀ 0 ▶</span>
          </div>
        </div>
      ))}
    </div>
  )
}

// Pipe/connector line
function Pipe({ color="#22c55e", width=32, dashed=false }) {
  return (
    <div style={{
      display:"flex",alignItems:"center",
      width,height:4,
      background:dashed?"transparent":color,
      borderTop:dashed?`2px dashed ${color}`:"none",
      flexShrink:0,marginTop:-2
    }}/>
  )
}

// Usage node (light bulb / radiator style)
function UsageNode({ icon="💡", label="", hasAlert=false, color="#22c55e", onClick }) {
  return (
    <div onClick={onClick} style={{
      position:"relative",display:"flex",flexDirection:"column",
      alignItems:"center",gap:4,cursor:onClick?"pointer":"default"
    }}>
      {hasAlert && (
        <div style={{
          position:"absolute",top:-6,left:"50%",transform:"translateX(-50%)",
          width:18,height:18,borderRadius:"50%",
          background:"#ef4444",display:"flex",alignItems:"center",justifyContent:"center",
          boxShadow:"0 2px 6px rgba(239,68,68,.4)",zIndex:2
        }}>
          <span style={{fontSize:9,color:"white",fontWeight:900}}>!</span>
        </div>
      )}
      <div style={{
        width:40,height:40,borderRadius:8,background:"white",
        border:`2px solid ${hasAlert?"#ef4444":color}`,
        display:"flex",alignItems:"center",justifyContent:"center",fontSize:18
      }}>{icon}</div>
      <span style={{fontSize:10,color:"#374151",fontWeight:500,textAlign:"center"}}>{label}</span>
    </div>
  )
}

// Alert side panel
function AlertPanel({ sensor, onOpenModal }) {
  const barH = [0.5,0.7,0.4,0.6,0.8,0.5,0.65,0.9,0.55,0.75,0.85,1.0]
  const barColors = barH.map(h=>h>0.85?"#ef4444":h>0.6?"#f59e0b":"#f97316")
  return (
    <div>
      <div style={{padding:"10px 14px",borderBottom:"1px solid #f1f5f9",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
        <div>
          <span style={{fontSize:10,color:"#64748b"}}>Sensor · </span>
          <span style={{fontSize:12,fontWeight:700,color:"#0f172a"}}>{sensor.name}</span>
        </div>
        <button style={{background:"none",border:"none",cursor:"pointer",color:"#94a3b8",fontSize:16}}>⋯</button>
      </div>
      {/* Tabs */}
      <div style={{display:"flex",borderBottom:"1px solid #f1f5f9"}}>
        <button style={{padding:"8px 12px",background:"none",border:"none",cursor:"pointer",fontSize:12,color:"#64748b"}}>Thông tin</button>
        <button style={{padding:"8px 12px",background:"none",border:"none",cursor:"pointer",fontSize:12,fontWeight:700,color:"#2563eb",borderBottom:"2px solid #2563eb"}}>Cảnh báo</button>
      </div>

      {/* Alert card */}
      <div style={{padding:"10px 14px"}}>
        <div style={{
          display:"flex",alignItems:"center",justifyContent:"space-between",
          marginBottom:10
        }}>
          <span style={{fontSize:12,fontWeight:600,color:"#374151"}}>Vượt ngưỡng cao/thấp</span>
          <div style={{display:"flex",gap:6}}>
            <span style={{fontSize:14}}>🔔</span>
            <button onClick={onOpenModal} style={{
              width:22,height:22,borderRadius:"50%",background:"#f59e0b",border:"none",
              cursor:"pointer",fontSize:10,display:"flex",alignItems:"center",justifyContent:"center"
            }}>✏</button>
          </div>
        </div>
        {[
          ["Tên",                "Dépassement seuils h..."],
          ["Mô tả",       "Cảnh báo này kích hoạt khi vượt ngưỡng cao hoặc thấp đã cấu hình trên cảm biến."],
          ["Ưu tiên",          "Nghiêm trọng"],
          ["Ngưỡng cao",        "26"],
          ["Mức nguy hiểm cao","2"],
          ["Ngưỡng thấp",         "19"],
          ["Mức nguy hiểm thấp","1"],
        ].map(([k,v])=>(
          <div key={k} style={{display:"flex",gap:8,padding:"4px 0",borderBottom:"1px solid #f8fafc"}}>
            <span style={{fontSize:10,color:"#94a3b8",width:110,flexShrink:0,textAlign:"right"}}>{k}</span>
            <span style={{fontSize:10,color:"#374151",flex:1}}>{v}</span>
          </div>
        ))}
      </div>

      {/* DERNIER MOIS GLISSANT mini chart */}
      <div style={{padding:"8px 14px 0",background:"#f8fafc",fontSize:9,fontWeight:700,color:"#94a3b8",letterSpacing:1}}>
        DERNIER MOIS GLISSANT
      </div>
      <div style={{padding:"8px 14px 14px",background:"#f8fafc"}}>
        <div style={{display:"flex",alignItems:"flex-end",gap:2,height:60,cursor:"pointer"}} onClick={onOpenModal}>
          {barH.map((h,i)=>(
            <div key={i} style={{
              flex:1,height:`${h*100}%`,background:barColors[i],
              borderRadius:"2px 2px 0 0",opacity:0.9
            }}/>
          ))}
        </div>
        <div style={{display:"flex",justifyContent:"space-between",marginTop:3}}>
          <span style={{fontSize:7,color:"#94a3b8"}}>mars-17</span>
          <span style={{fontSize:7,color:"#94a3b8"}}>sept-17</span>
          <span style={{fontSize:7,color:"#94a3b8"}}>mars-18</span>
        </div>
      </div>
    </div>
  )
}

// Alert Modal (Image 2)
function AlertModal({ sensor, onClose }) {
  const [alertTab, setAlertTab]       = useState("Cảnh báo mới")
  const [chartTab, setChartTab]       = useState("Theo mức độ")
  const ALERT_TABS = ["Cảnh báo mới","Đã xác nhận","Tất cả cảnh báo"]
  const alarms = [
    { date:"23/11/2018", time:"10:00", obj:"Cảm biến nhiệt độ phòng", val:17, crit:"high" },
    { date:"15/08/2018", time:"16:00", obj:"Cảm biến nhiệt độ phòng", val:28, crit:"mid" },
  ]
  const barH = [0.3,0.5,0.2,0.6,0.4,0.7,0.3,0.5,0.4,0.8,0.6,1.0]
  const barC = barH.map(h=>h>0.85?"#ef4444":h>0.5?"#f59e0b":"#f97316")
  const donut_r=44, donut_c=2*Math.PI*donut_r, donut_mid=donut_c*0.5, donut_lo=donut_c*0.3

  return (
    <div style={{
      position:"fixed",inset:0,background:"rgba(0,0,0,0.4)",
      display:"flex",alignItems:"center",justifyContent:"center",zIndex:3000
    }} onClick={e=>{if(e.target===e.currentTarget)onClose()}}>
      <div style={{
        background:"white",borderRadius:10,width:820,maxHeight:"82vh",overflow:"auto",
        boxShadow:"0 20px 60px rgba(0,0,0,0.25)"
      }}>
        {/* Modal header */}
        <div style={{padding:"14px 20px",borderBottom:"1px solid #e2e8f0",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
          <span style={{fontSize:14,fontWeight:700,color:"#0f172a"}}>
            {sensor.name} · Dépassement seuils haut/bas
          </span>
          <button onClick={onClose} style={{background:"none",border:"none",cursor:"pointer",fontSize:20,color:"#64748b"}}>×</button>
        </div>

        {/* Modal body */}
        <div style={{display:"grid",gridTemplateColumns:"1fr 1.4fr",gap:0}}>
          {/* Left: donut + evolution */}
          <div style={{borderRight:"1px solid #e2e8f0",padding:"16px 20px"}}>
            {/* Sub-tabs */}
            <div style={{display:"flex",gap:0,marginBottom:16}}>
              {["Cảnh báo mới","Theo mức độ","Theo ngưỡng"].map((t,i)=>(
                <button key={t} onClick={()=>setChartTab(t)} style={{
                  padding:"6px 12px",border:"none",cursor:"pointer",fontSize:11,fontWeight:500,
                  background:"transparent",color:chartTab===t?"#2563eb":"#64748b",
                  borderBottom:chartTab===t?"2px solid #2563eb":"2px solid transparent"
                }}>{t}</button>
              ))}
            </div>

            {/* Donut */}
            <div style={{display:"flex",justifyContent:"center",marginBottom:20}}>
              <div style={{position:"relative",width:120,height:120}}>
                <svg viewBox="0 0 110 110" style={{width:120,height:120}}>
                  <circle cx={55} cy={55} r={donut_r} fill="none" stroke="#fed7aa" strokeWidth={14}/>
                  <circle cx={55} cy={55} r={donut_r} fill="none" stroke="#f97316" strokeWidth={14}
                    strokeDasharray={`${donut_lo} ${donut_c-donut_lo}`} strokeDashoffset={donut_c/4}/>
                  <circle cx={55} cy={55} r={donut_r} fill="none" stroke="#ef4444" strokeWidth={14}
                    strokeDasharray={`${donut_mid*0.2} ${donut_c-donut_mid*0.2}`}
                    strokeDashoffset={donut_c/4-donut_lo}/>
                </svg>
                <div style={{position:"absolute",inset:0,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
                  <span style={{fontSize:22,fontWeight:800,color:"#0f172a"}}>2</span>
                  <span style={{fontSize:10,color:"#64748b"}}>cảnh báo</span>
                </div>
              </div>
            </div>

            {/* Evolution */}
            <div style={{display:"flex",gap:0,marginBottom:10}}>
              {["Diễn biến hàng tháng","Theo mức độ","Theo ngưỡng"].map((t,i)=>(
                <button key={t} style={{
                  padding:"5px 10px",border:"none",cursor:"pointer",fontSize:10,fontWeight:500,
                  background:"transparent",color:i===0?"#2563eb":"#64748b",
                  borderBottom:i===0?"2px solid #2563eb":"2px solid transparent"
                }}>{t}</button>
              ))}
            </div>
            <div style={{paddingLeft:20,position:"relative"}}>
              {[0,1,2,3].map(v=>(
                <div key={v} style={{position:"absolute",left:0,bottom:`${(v/3)*80}px`,fontSize:7,color:"#94a3b8"}}>{v}</div>
              ))}
              <div style={{display:"flex",alignItems:"flex-end",gap:3,height:80,borderBottom:"1px solid #e2e8f0"}}>
                {barH.map((h,i)=>(
                  <div key={i} style={{flex:1,height:`${h*100}%`,background:barC[i],borderRadius:"2px 2px 0 0"}}/>
                ))}
              </div>
              <div style={{display:"flex",justifyContent:"space-between",marginTop:3}}>
                <span style={{fontSize:7,color:"#94a3b8"}}>mars-17</span>
                <span style={{fontSize:7,color:"#94a3b8"}}>sept-17</span>
                <span style={{fontSize:7,color:"#94a3b8"}}>mars-18</span>
              </div>
            </div>
          </div>

          {/* Right: alarm table */}
          <div style={{padding:"16px 20px"}}>
            <div style={{display:"flex",gap:0,marginBottom:14}}>
              {ALERT_TABS.map(t=>(
                <button key={t} onClick={()=>setAlertTab(t)} style={{
                  padding:"6px 12px",border:"none",cursor:"pointer",fontSize:11,fontWeight:500,
                  background:"transparent",color:alertTab===t?"#2563eb":"#64748b",
                  borderBottom:alertTab===t?"2px solid #2563eb":"2px solid transparent"
                }}>{t}</button>
              ))}
            </div>

            <table style={{width:"100%",borderCollapse:"collapse",fontSize:11}}>
              <thead>
                <tr style={{borderBottom:"2px solid #e2e8f0"}}>
                  <th style={{padding:"6px 8px",textAlign:"left",color:"#64748b",fontWeight:600,width:16}}>
                    <input type="checkbox"/>
                  </th>
                  {["Ngày","Giờ","Đối tượng","Giá trị","Mức độ"].map(h=>(
                    <th key={h} style={{padding:"6px 8px",textAlign:"left",color:"#64748b",fontWeight:600}}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {alarms.map((a,i)=>(
                  <tr key={i} style={{borderBottom:"1px solid #f1f5f9"}}>
                    <td style={{padding:"8px"}}><input type="checkbox"/></td>
                    <td style={{padding:"8px",color:"#374151"}}>{a.date}</td>
                    <td style={{padding:"8px",color:"#374151"}}>{a.time}</td>
                    <td style={{padding:"8px",color:"#374151"}}>{a.obj}</td>
                    <td style={{padding:"8px",color:"#374151",fontWeight:600}}>{a.val}</td>
                    <td style={{padding:"8px"}}>
                      <div style={{
                        width:10,height:10,borderRadius:"50%",
                        background:a.crit==="high"?"#ef4444":"#f97316"
                      }}/>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <button style={{
              marginTop:24,padding:"10px 20px",background:"#22c55e",color:"white",
              border:"none",borderRadius:6,cursor:"pointer",fontSize:12,fontWeight:600,
              boxShadow:"0 2px 8px rgba(34,197,94,.3)"
            }}>Xác nhận cảnh báo đã chọn</button>
          </div>
        </div>
      </div>
    </div>
  )
}

// Add-transformation dropdown
function AddTransformMenu({ onClose }) {
  const items = ["Sản xuất nhiệt","Sản xuất nước nóng","Sản xuất lạnh","Sản xuất điện","Khí nén"]
  return (
    <div style={{
      background:"white",border:"1px solid #e2e8f0",borderRadius:8,
      boxShadow:"0 8px 24px rgba(0,0,0,0.12)",minWidth:200,overflow:"hidden"
    }} onClick={e=>e.stopPropagation()}>
      {items.map(item=>(
        <div key={item} style={{
          display:"flex",alignItems:"center",justifyContent:"space-between",
          padding:"8px 14px",cursor:"pointer",fontSize:11,color:"#374151",
          transition:"background .1s"
        }}
          onMouseEnter={e=>e.currentTarget.style.background="#f8fafc"}
          onMouseLeave={e=>e.currentTarget.style.background="white"}
        >
          <span>{item}</span>
          <span style={{color:"#94a3b8",fontSize:12}}>◀ 0 ▶</span>
        </div>
      ))}
      <div style={{
        display:"flex",alignItems:"center",justifyContent:"space-between",
        padding:"8px 14px",borderTop:"1px solid #f1f5f9",cursor:"pointer",fontSize:11,color:"#374151"
      }}>
        <span>Biến đổi tuỳ chỉnh</span>
        <span style={{color:"#94a3b8"}}>∨</span>
      </div>
    </div>
  )
}



const SYNOPTIC_SENSORS = [
  { id:"SY1", name:"Température logement 211", fluid:"Temperature", hasAlert:true },
  { id:"SY2", name:"Electricity consumption",  fluid:"Điện", hasAlert:false },
]

function SynopticPanel({ site }) {
  const [activeSubTab,     setActiveSubTab]     = useState("Hệ thống năng lượng")
  const [expandedTransfo,  setExpandedTransfo]  = useState({})
  const [selectedSensor,   setSelectedSensor]   = useState(SYNOPTIC_SENSORS[0])
  const [alertModal,       setAlertModal]        = useState(false)
  const [addTransformMenu, setAddTransformMenu]  = useState(false)
  const [addUsagePopup,    setAddUsagePopup]     = useState(null)

  // Ateliers désactivés par site
  const DISABLED_TABS = {
    "VNHH01": ["PX Cán Thép", "PX Hồ Quang"],
    "VNVC01": ["PX Hồ Quang"],
    "VNPP01": ["PX Thiêu Kết", "PX Luyện Gang"],
  }
  const disabledForSite = site ? (DISABLED_TABS[site.id] || []) : []

  const ALL_SUB_TABS = ["Hệ thống năng lượng","Địa điểm của tôi","Cảm biến","PX Thiêu Kết","PX Luyện Gang","PX Hồ Quang","PX Luyện Thép","PX Cán Thép","PX Khí"]
  const SUB_TABS = ALL_SUB_TABS.filter(t => !disabledForSite.includes(t))

  const toggleTransfo = (key) => setExpandedTransfo(p=>({...p,[key]:!p[key]}))

  return (
    <div style={{display:"flex",flexDirection:"column",flex:1,overflow:"hidden",background:"#f8fafc"}}
      onClick={()=>{setAddTransformMenu(false);setAddUsagePopup(null)}}>

      {/* Sub-tab toolbar */}
      <div style={{
        background:"white",borderBottom:"1px solid #e2e8f0",
        padding:"8px 16px",display:"flex",alignItems:"center",gap:8,flexShrink:0
      }}>
        <div style={{display:"flex",gap:4}}>
          {SUB_TABS.map(t=>(
            <button key={t} onClick={()=>setActiveSubTab(t)} style={{
              padding:"7px 14px",border:"none",cursor:"pointer",fontSize:12,fontWeight:500,
              background:t==="Hệ thống năng lượng"&&activeSubTab===t?"#1e3a5f":activeSubTab===t?"#1e3a5f":"transparent",
              color:activeSubTab===t?"white":"#64748b",
              borderRadius:6,transition:"all .15s",whiteSpace:"nowrap"
            }}>{t}</button>
          ))}
        </div>
        <div style={{flex:1}}/>
        <button style={{background:"none",border:"none",cursor:"pointer",fontSize:12,color:"#64748b"}}>Thu gọn tất cả</button>
        <button style={{background:"none",border:"none",cursor:"pointer",fontSize:12,color:"#2563eb",fontWeight:600}}>Mở rộng tất cả</button>
        {/* Close / Save */}
        <button style={{
          width:28,height:28,borderRadius:"50%",background:"#ef4444",border:"none",
          cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",
          color:"white",fontSize:14,boxShadow:"0 2px 6px rgba(239,68,68,.3)"
        }}>×</button>
        <button style={{
          width:28,height:28,borderRadius:"50%",background:"#22c55e",border:"none",
          cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",
          color:"white",fontSize:13,boxShadow:"0 2px 6px rgba(34,197,94,.3)"
        }}>💾</button>
      </div>

      {/* Content */}
      <div style={{flex:1,display:"flex",overflow:"hidden"}}>

        {activeSubTab === "PX Thiêu Kết" ? (
          <PXTKPanel/>
        ) : activeSubTab === "PX Luyện Gang" ? (
          <PXLGPanel/>
        ) : activeSubTab === "PX Luyện Thép" ? (
          <PXLTPanel/>
        ) : activeSubTab === "PX Cán Thép" ? (
          <PXCTPanel/>
        ) : activeSubTab === "PX Khí" ? (
          <PXKhiPanel/>
        ) : activeSubTab === "PX Hồ Quang" ? (
          <PXHQPanel/>
        ) : (
        <>
        {/* Main 3-column canvas */}
        <div style={{flex:1,overflow:"auto",padding:"16px"}}>
          <div style={{display:"flex",gap:0,minWidth:600}}>

            {/* ── FOURNITURES ── */}
            <div style={{flex:1,borderRight:"1px solid #e2e8f0",paddingRight:12}}>
              <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:12}}>
                <span style={{fontSize:11,fontWeight:700,color:"#64748b",letterSpacing:1}}>Nguồn cung</span>
                <button style={{
                  width:22,height:22,borderRadius:"50%",background:"#22c55e",border:"none",
                  cursor:"pointer",fontSize:14,color:"white",display:"flex",alignItems:"center",justifyContent:"center",
                  boxShadow:"0 1px 4px rgba(34,197,94,.4)"
                }}>+</button>
              </div>

              {/* Gaz naturel */}
              <div style={{
                background:"white",border:"1px solid #e2e8f0",borderRadius:8,
                padding:"10px 12px",marginBottom:10
              }}>
                <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:8}}>
                  <div style={{display:"flex",alignItems:"center",gap:6}}>
                    <span style={{fontSize:14}}>🔥</span>
                    <span style={{fontSize:12,fontWeight:600,color:"#f59e0b"}}>Khí thiên nhiên (1)</span>
                  </div>
                  <button style={{background:"none",border:"none",cursor:"pointer",color:"#94a3b8",fontSize:14}}>⋮</button>
                </div>
                <div style={{display:"flex",alignItems:"center",gap:4}}>
                  <div style={{width:28,height:3,background:"#f59e0b",borderRadius:2}}/>
                  <FlowNode color="#f59e0b" hasAlert size={30}
                    onClick={()=>setSelectedSensor(SYNOPTIC_SENSORS[0])}/>
                  <div style={{width:28,height:3,background:"#ef4444",borderRadius:2}}/>
                  <div style={{width:12,height:0,borderTop:"3px dashed #ef4444"}}/>
                  <span style={{fontSize:14}}>➝</span>
                </div>
                <button style={{
                  marginTop:8,fontSize:10,color:"#2563eb",background:"#eff6ff",
                  border:"none",borderRadius:4,padding:"3px 8px",cursor:"pointer"
                }}>+ Thêm cảm biến</button>
              </div>

              {/* Électricité */}
              <div style={{
                background:"white",border:"1px solid #e2e8f0",borderRadius:8,
                padding:"10px 12px"
              }}>
                <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:8}}>
                  <div style={{display:"flex",alignItems:"center",gap:6}}>
                    <span style={{fontSize:14}}>⚡</span>
                    <span style={{fontSize:12,fontWeight:600,color:"#22c55e"}}>Điện (2)</span>
                  </div>
                  <button style={{background:"none",border:"none",cursor:"pointer",color:"#94a3b8",fontSize:14}}>⋮</button>
                </div>
                {[1,2].map(n=>(
                  <div key={n} style={{display:"flex",alignItems:"center",gap:4,marginBottom:6}}>
                    <div style={{width:24,height:3,background:"#22c55e",borderRadius:2}}/>
                    <FlowNode color="#22c55e" size={28}
                      onClick={()=>setSelectedSensor(SYNOPTIC_SENSORS[1])}/>
                    <div style={{width:24,height:3,background:"#22c55e",borderRadius:2}}/>
                    <span style={{fontSize:12}}>➝</span>
                  </div>
                ))}
                <button style={{
                  marginTop:4,fontSize:10,color:"#2563eb",background:"#eff6ff",
                  border:"none",borderRadius:4,padding:"3px 8px",cursor:"pointer"
                }}>+ Thêm cảm biến</button>
              </div>
            </div>

            {/* ── TRANSFORMATIONS ── */}
            <div style={{flex:1.2,borderRight:"1px solid #e2e8f0",padding:"0 12px"}}>
              <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:12}}>
                <span style={{fontSize:11,fontWeight:700,color:"#64748b",letterSpacing:1}}>Biến đổi</span>
                <div style={{position:"relative"}}>
                  <button onClick={e=>{e.stopPropagation();setAddTransformMenu(v=>!v)}} style={{
                    width:22,height:22,borderRadius:"50%",background:"#22c55e",border:"none",
                    cursor:"pointer",fontSize:14,color:"white",display:"flex",alignItems:"center",justifyContent:"center",
                    boxShadow:"0 1px 4px rgba(34,197,94,.4)"
                  }}>+</button>
                  {addTransformMenu && (
                    <div style={{position:"absolute",top:28,right:0,zIndex:100}}>
                      <AddTransformMenu onClose={()=>setAddTransformMenu(false)}/>
                    </div>
                  )}
                </div>
              </div>

              {/* Production de chaleur */}
              <div style={{
                background:"white",border:"1px solid #e2e8f0",borderRadius:8,
                padding:"10px 12px",marginBottom:10
              }}>
                <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:8}}>
                  <TransformBox label="Sản xuất nhiệt"
                    subItems={[]} expanded={false} onToggle={()=>toggleTransfo("chaleur")}/>
                  <div style={{display:"flex",gap:4,alignItems:"center"}}>
                    <button style={{
                      width:22,height:22,borderRadius:"50%",background:"#22c55e",border:"none",
                      cursor:"pointer",fontSize:12,color:"white"
                    }}>+</button>
                    <button style={{
                      width:22,height:22,borderRadius:"50%",background:"#22c55e",border:"none",
                      cursor:"pointer",fontSize:12,color:"white"
                    }}>+</button>
                  </div>
                </div>
                <div style={{display:"flex",alignItems:"center",gap:4,padding:"4px 0"}}>
                  <div style={{width:20,height:3,background:"#f59e0b",borderRadius:2}}/>
                  <div style={{width:20,height:3,background:"#22c55e",borderRadius:2}}/>
                  <div style={{
                    width:32,height:32,background:"#f1f5f9",border:"1px solid #e2e8f0",borderRadius:4,
                    display:"flex",alignItems:"center",justifyContent:"center",fontSize:16
                  }}>⚙</div>
                  <div style={{width:20,height:3,background:"#ef4444",borderRadius:2}}/>
                  <span style={{fontSize:10}}>➝</span>
                </div>
              </div>

              {/* Production d'électricité */}
              <div style={{
                background:"white",border:"1px solid #e2e8f0",borderRadius:8,
                padding:"10px 12px"
              }}>
                <TransformBox label="Sản xuất điện"
                  subItems={expandedTransfo["elec"]?["Sous-compteur 1","Sous-compteur 2"]:[]}
                  expanded={!!expandedTransfo["elec"]}
                  onToggle={()=>toggleTransfo("elec")}/>
                <div style={{display:"flex",alignItems:"center",gap:4,padding:"8px 0 4px"}}>
                  <div style={{width:20,height:3,background:"#f59e0b",borderRadius:2}}/>
                  <div style={{width:20,height:3,background:"#22c55e",borderRadius:2}}/>
                  <div style={{
                    width:32,height:32,background:"#f1f5f9",border:"1px solid #e2e8f0",borderRadius:4,
                    display:"flex",alignItems:"center",justifyContent:"center",fontSize:16
                  }}>⚙</div>
                  <div style={{width:20,height:3,background:"#22c55e",borderRadius:2}}/>
                  <span style={{fontSize:10}}>➝</span>
                  <FlowNode color="#22c55e" size={26}/>
                  <div style={{width:16,height:3,background:"#22c55e",borderRadius:2}}/>
                  <span style={{fontSize:10}}>➝</span>
                </div>
              </div>
            </div>

            {/* ── USAGES ── */}
            <div style={{flex:1,paddingLeft:12}}>
              <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:12}}>
                <span style={{fontSize:11,fontWeight:700,color:"#64748b",letterSpacing:1}}>Sử dụng</span>
                <button style={{
                  width:22,height:22,borderRadius:"50%",background:"#22c55e",border:"none",
                  cursor:"pointer",fontSize:14,color:"white",display:"flex",alignItems:"center",justifyContent:"center",
                  boxShadow:"0 1px 4px rgba(34,197,94,.4)"
                }}>+</button>
              </div>

              {/* Chauffage */}
              <div style={{
                background:"white",border:"1px solid #e2e8f0",borderRadius:8,
                padding:"10px 12px",marginBottom:10
              }}>
                <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:8}}>
                  <div style={{display:"flex",alignItems:"center",gap:6}}>
                    <span style={{fontSize:14}}>🌡</span>
                    <span style={{fontSize:12,fontWeight:600,color:"#ef4444"}}>Sưởi ấm</span>
                  </div>
                  <button style={{background:"none",border:"none",cursor:"pointer",color:"#94a3b8",fontSize:14}}>⋮</button>
                </div>
                <div style={{display:"flex",alignItems:"center",gap:4}}>
                  <div style={{width:20,height:3,background:"#ef4444",borderRadius:2}}/>
                  <FlowNode color="#ef4444" hasAlert size={28}
                    onClick={()=>setSelectedSensor(SYNOPTIC_SENSORS[0])}/>
                  <div style={{width:20,height:3,background:"#ef4444",borderRadius:2}}/>
                  <div style={{
                    width:28,height:28,background:"white",border:"1px solid #ef4444",borderRadius:4,
                    display:"flex",alignItems:"center",justifyContent:"center",fontSize:14
                  }}>🏠</div>
                  <button style={{
                    width:18,height:18,borderRadius:"50%",background:"#22c55e",border:"none",
                    cursor:"pointer",fontSize:11,color:"white"
                  }}>+</button>
                </div>
                <button style={{
                  marginTop:8,fontSize:10,color:"#2563eb",background:"#eff6ff",
                  border:"none",borderRadius:4,padding:"3px 8px",cursor:"pointer"
                }}>+ Thêm bộ đếm</button>
              </div>

              {/* Éclairage */}
              <div style={{
                background:"white",border:"1px solid #e2e8f0",borderRadius:8,
                padding:"10px 12px",marginBottom:10
              }}>
                <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:8}}>
                  <div style={{display:"flex",alignItems:"center",gap:6}}>
                    <span style={{fontSize:14}}>💡</span>
                    <span style={{fontSize:12,fontWeight:600,color:"#22c55e"}}>Chiếu sáng</span>
                  </div>
                  <button style={{background:"none",border:"none",cursor:"pointer",color:"#94a3b8",fontSize:14}}>⋮</button>
                </div>
                <div style={{display:"flex",alignItems:"center",gap:4}}>
                  <div style={{width:20,height:3,background:"#22c55e",borderRadius:2}}/>
                  <FlowNode color="#22c55e" size={28}
                    onClick={()=>setSelectedSensor(SYNOPTIC_SENSORS[1])}/>
                  <div style={{width:20,height:3,background:"#22c55e",borderRadius:2}}/>
                  <div style={{
                    width:28,height:28,background:"white",border:"1px solid #e2e8f0",borderRadius:4,
                    display:"flex",alignItems:"center",justifyContent:"center",fontSize:14,opacity:0.5
                  }}>💡</div>
                </div>
                <button style={{
                  marginTop:8,fontSize:10,color:"#2563eb",background:"#eff6ff",
                  border:"none",borderRadius:4,padding:"3px 8px",cursor:"pointer"
                }} onClick={e=>{e.stopPropagation();setAddUsagePopup("eclairage")}}>+ Thêm bộ đếm</button>
                {addUsagePopup==="eclairage"&&(
                  <div style={{
                    marginTop:4,background:"white",border:"1px solid #e2e8f0",borderRadius:6,
                    padding:8,fontSize:11,color:"#374151",boxShadow:"0 4px 12px rgba(0,0,0,0.1)"
                  }} onClick={e=>e.stopPropagation()}>
                    Ajouter un compteur →
                  </div>
                )}
              </div>

              {/* Đầu ra */}
              <div style={{
                background:"white",border:"1px solid #e2e8f0",borderRadius:8,
                padding:"10px 12px"
              }}>
                <div style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                  <span style={{fontSize:12,fontWeight:600,color:"#64748b"}}>Đầu ra</span>
                  <button style={{
                    width:22,height:22,borderRadius:"50%",background:"#22c55e",border:"none",
                    cursor:"pointer",fontSize:14,color:"white",display:"flex",alignItems:"center",justifyContent:"center"
                  }}>+</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right panel: sensor detail / alerts */}
        <div style={{
          width:260,background:"white",borderLeft:"1px solid #e2e8f0",
          flexShrink:0,overflowY:"auto"
        }}>
          {selectedSensor ? (
            <AlertPanel sensor={selectedSensor} onOpenModal={()=>setAlertModal(true)}/>
          ) : (
            <div style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center",color:"#94a3b8",fontSize:12,padding:20,textAlign:"center"}}>
              Please select an object to display its information
            </div>
          )}
        </div>
        </>
        )}
      </div>

      {/* Alert modal */}
      {alertModal && selectedSensor && (
        <AlertModal sensor={selectedSensor} onClose={()=>setAlertModal(false)}/>
      )}
    </div>
  )
}

// ─── My Site Info Panel ───────────────────────────────────
function MySiteInfoPanel() {
  const NAV_SECTIONS = [
    "Tổng quan","Vị trí","Hồ sơ năng lượng","Hồ sơ tài chính",
    "Thông tin khác","Mô tả địa điểm","GRESB","Energy","Carbon",
    "Water","Waste and Ressources","Di chuyển & Vận chuyển","Môi trường"
  ]
  const [activeSection, setActiveSection] = useState("Tổng quan")
  const [form, setForm] = useState({
    code:"DEMO16", name:"Siège social", wording:"", parentOrg:"France",
    assignee:"", labels:"", recipients:"",
    address:"88 avenue du Général Le", longitude:"2.236322", latitude:"48.831466",
    altitude:"", region:"", postalCode:"92100", city:"Boulogne-Billancourt", country:"France",
    sitTypology:"Industry", function:"", subFunction:"",
    climateRisk:"", vegetalRoof:"", semiPerme:"", openGround:"", nonArtificial:"", closeToPub:"",
    publicTrans1:"", publicTrans2:"", chargingSta:"", freeFloating:"",
    distanceTo:"", driveIn:"", publicTPercent:"", showerAndL:"",
    secureBike:"", walkingPercent:"", cyclingPercent:""
  })
  const s = (k) => (e) => setForm(f=>({...f,[k]:e.target.value}))

  const contentRef = useRef(null)

  const scrollTo = (id) => {
    setActiveSection(id)
    const el = document.getElementById("msi-"+id)
    if (el && contentRef.current) {
      contentRef.current.scrollTo({ top: el.offsetTop - 12, behavior:"smooth" })
    }
  }

  return (
    <div style={{flex:1,display:"flex",overflow:"hidden"}}>

      {/* Main area: left nav + form + right panel */}
      <div style={{flex:1,display:"flex",overflow:"hidden"}}>

        {/* Left nav */}
        <div style={{
          width:175,background:"white",borderRight:"1px solid #e2e8f0",
          overflowY:"auto",padding:"16px 0",flexShrink:0
        }}>
          <div style={{
            display:"flex",alignItems:"center",gap:8,padding:"0 16px 12px",
            borderBottom:"1px solid #f1f5f9",marginBottom:8
          }}>
            <div style={{width:10,height:10,borderRadius:"50%",background:"#2563eb",flexShrink:0}}/>
            <span style={{fontSize:12,fontWeight:700,color:"#0f172a"}}>Site information</span>
          </div>
          {NAV_SECTIONS.map(sec=>(
            <div key={sec} onClick={()=>scrollTo(sec)} style={{
              padding:"7px 16px 7px 26px",cursor:"pointer",fontSize:12,
              color: activeSection===sec?"#2563eb":"#374151",
              fontWeight: activeSection===sec?700:400,
              background: activeSection===sec?"#eff6ff":"transparent",
              borderLeft: activeSection===sec?"3px solid #2563eb":"3px solid transparent",
              transition:"all .1s"
            }}>
              {sec}
            </div>
          ))}
        </div>

        {/* Scrollable form */}
        <div ref={contentRef} style={{flex:1,overflowY:"auto",padding:"20px 24px",background:"#f8fafc"}}>

          {/* ── Overview ── */}
          <div id="msi-Overview">
            <FSectionTitle>Tổng quan</FSectionTitle>
            <FRow2>
              <div>
                <FField label="Code"         value={form.code}      disabled/>
                <FField label="Name"         value={form.name}      onChange={s("name")}/>
                <FField label="Wording"      value={form.wording}   onChange={s("wording")}/>
                <FField label="Parent organ..." value={form.parentOrg} onChange={s("parentOrg")}
                  placeholder="France"/>
              </div>
              <div>
                <FField label="Người phụ trách"     value={form.assignee}  onChange={s("assignee")}/>
                <FField label="Nhãn"       value={form.labels}    onChange={s("labels")}/>
                <FTextarea label="Recipients list" value={form.recipients} onChange={s("recipients")}/>
              </div>
            </FRow2>
          </div>

          {/* ── Location ── */}
          <div id="msi-Location">
            <FSectionTitle>Vị trí</FSectionTitle>
            <FRow2>
              <div>
                <FField label="Address"     value={form.address}    onChange={s("address")}/>
                <div style={{marginBottom:10}}>
                  <div style={{display:"flex",alignItems:"center",gap:8}}>
                    <span style={{fontSize:11,color:"#2563eb",width:130,flexShrink:0,textAlign:"right",cursor:"pointer"}}>
                      Additional address details
                    </span>
                    <span style={{color:"#2563eb",fontSize:11}}>▾</span>
                  </div>
                </div>
                <FField label="Region"      value={form.region}     onChange={s("region")}/>
                <FField label="Postal code" value={form.postalCode} onChange={s("postalCode")}/>
                <FField label="City"        value={form.city}       onChange={s("city")}/>
                <FSelect label="Country"   value={form.country}    onChange={s("country")}
                  options={["France","Germany","Italy","United Kingdom","Spain","Belgium"]}/>
              </div>
              <div>
                <FField label="Longitude"   value={form.longitude}  onChange={s("longitude")}/>
                <FField label="Latitude"    value={form.latitude}   onChange={s("latitude")}/>
                <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:10}}>
                  <span style={{fontSize:11,color:"#64748b",width:130,flexShrink:0,textAlign:"right"}}>Altitude</span>
                  <input value={form.altitude} onChange={s("altitude")}
                    style={{flex:1,border:"1px solid #e2e8f0",borderRadius:5,padding:"5px 9px",fontSize:12,outline:"none"}}/>
                  <span style={{fontSize:11,color:"#94a3b8",marginLeft:4}}>m</span>
                  <div style={{width:20,height:20,borderRadius:"50%",background:"#2563eb",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                    <span style={{fontSize:9,color:"white",fontWeight:700}}>i</span>
                  </div>
                </div>
              </div>
            </FRow2>
          </div>

          {/* ── Energy profile ── */}
          <div id="msi-Energy profile">
            <FSectionTitle>Hồ sơ năng lượng</FSectionTitle>
            <FRow2>
              <div>
                <FSubtitle>Technical features</FSubtitle>
                <FSelect label="Site typology" value={form.sitTypology} onChange={s("sitTypology")}
                  options={["Industry","Office","Retail","Residential","Education","Healthcare","Hotel","Other"]}/>
                <FField label="Function"     value={form.function}    onChange={s("function")}/>
                <FField label="Sub-function" value={form.subFunction} onChange={s("subFunction")}/>
              </div>
              <div>
                <FSubtitle>Reference indicators</FSubtitle>
                {["Consumptions and CO2 emissions","Energetic performance","Hiệu suất môi trường"].map(item=>(
                  <div key={item} style={{
                    display:"flex",alignItems:"center",gap:6,padding:"7px 0",
                    borderBottom:"1px solid #f1f5f9",cursor:"pointer"
                  }}>
                    <span style={{color:"#2563eb",fontSize:12}}>›</span>
                    <span style={{fontSize:12,color:"#2563eb"}}>{item}</span>
                  </div>
                ))}
              </div>
            </FRow2>
          </div>

          {/* ── Financial profile ── */}
          <div id="msi-Financial profile">
            <FSectionTitle>Hồ sơ tài chính</FSectionTitle>
            <FRow2>
              <div>
                <FField label="Asset value"         placeholder="—"/>
                <FField label="Currency"            placeholder="EUR"/>
                <FField label="Acquisition date"    placeholder="dd/mm/yyyy"/>
                <FField label="Construction year"   placeholder="—"/>
              </div>
              <div>
                <FField label="Gross floor area"  placeholder="2 000 m²"/>
                <FField label="Net floor area"    placeholder="—"/>
                <FField label="Rental area"       placeholder="—"/>
                <FField label="Occupancy rate"    placeholder="—"/>
              </div>
            </FRow2>
          </div>

          {/* ── Other information ── */}
          <div id="msi-Other information">
            <FSectionTitle>Thông tin khác</FSectionTitle>
            <FRow2>
              <div>
                <FField label="Opening year"     placeholder="—"/>
                <FField label="Renovation year"  placeholder="—"/>
                <FSelect label="Ownership"       value=""
                  options={["Owner","Tenant","Co-owner"]}/>
              </div>
              <div>
                <FField label="Number of floors" placeholder="—"/>
                <FField label="Number of units"  placeholder="—"/>
                <FField label="External ref."    placeholder="—"/>
              </div>
            </FRow2>
          </div>

          {/* ── Site description ── */}
          <div id="msi-Site description">
            <FSectionTitle>Mô tả địa điểm</FSectionTitle>
            <FTextarea label="Mô tả" value="" onChange={()=>{}}/>
          </div>

          {/* ── GRESB ── */}
          <div id="msi-GRESB">
            <FSectionTitle>GRESB</FSectionTitle>
            <FRow2>
              <div>
                <FSelect label="Asset type"     value="" options={["Office","Retail","Industrial","Residential","Diversified"]}/>
                <FSelect label="Country"        value="France" options={["France","Germany","United Kingdom","Italy","Spain"]}/>
                <FField  label="GRESB code"     placeholder="—"/>
              </div>
              <div>
                <FField  label="NLA (m²)"       placeholder="—"/>
                <FField  label="GFA (m²)"       placeholder="—"/>
                <FSelect label="Certification"  value="" options={["HQE","BREEAM","LEED","DGNB","None"]}/>
              </div>
            </FRow2>
          </div>

          {/* ── Energy ── */}
          <div id="msi-Energy">
            <FSectionTitle>Energy</FSectionTitle>
            <FRow2>
              <div>
                <FSelect label="Energy label"   value="A" options={["A","B","C","D","E","F","G"]}/>
                <FField  label="DPE reference"  placeholder="—"/>
                <FField  label="DPE date"       placeholder="dd/mm/yyyy"/>
              </div>
              <div>
                <FField label="Primary energy (kWh/m²)" placeholder="—"/>
                <FField label="Final energy (kWh/m²)"   placeholder="—"/>
                <FField label="Climate zone"             placeholder="—"/>
              </div>
            </FRow2>
          </div>

          {/* ── Carbon ── */}
          <div id="msi-Carbon">
            <FSectionTitle>Carbon</FSectionTitle>
            <FRow2>
              <div>
                <FField label="CO₂ target (tCO₂)" placeholder="—"/>
                <FField label="Baseline year"      placeholder="—"/>
                <FSelect label="Scope"  value="" options={["Scope 1","Scope 1+2","Scope 1+2+3"]}/>
              </div>
              <div>
                <FField label="CO₂ factor Elec."  placeholder="—"/>
                <FField label="CO₂ factor Gas"    placeholder="—"/>
                <FField label="CO₂ factor Water"  placeholder="—"/>
              </div>
            </FRow2>
          </div>

          {/* ── Water ── */}
          <div id="msi-Water">
            <FSectionTitle>Water</FSectionTitle>
            <FRow2>
              <div>
                <FField label="Water target (m³)"  placeholder="—"/>
                <FSelect label="Water source"  value="" options={["Municipal","Well","Rainwater","Mixed"]}/>
              </div>
              <div>
                <FField label="Irrigation area (m²)" placeholder="—"/>
                <FField label="Cooling tower"         placeholder="—"/>
              </div>
            </FRow2>
          </div>

          {/* ── Waste and Resources ── */}
          <div id="msi-Waste and Ressources">
            <FSectionTitle>Rác thải & Tài nguyên</FSectionTitle>
            <FRow2>
              <div>
                <FSelect label="Waste sorting"   value="" options={["Yes","No","Partial"]}/>
                <FField  label="Recycling rate"  placeholder="—"/>
              </div>
              <div>
                <FField  label="Waste target (t)" placeholder="—"/>
                <FSelect label="Composting"       value="" options={["Yes","No"]}/>
              </div>
            </FRow2>
          </div>

          {/* ── Mobility and Transport ── */}
          <div id="msi-Mobility and Transport">
            <FSectionTitle>Di chuyển & Vận chuyển</FSectionTitle>
            <FRow2>
              <div>
                <FSelect label="Public trans..." value={form.publicTrans1} onChange={s("publicTrans1")} options={["","Bus","Metro","Tram","RER","Train"]}/>
                <FSelect label="Public trans..." value={form.publicTrans2} onChange={s("publicTrans2")} options={["","Bus","Metro","Tram","RER","Train"]}/>
                <FField  label="Distance to ..." value={form.distanceTo}  onChange={s("distanceTo")} placeholder="—"/>
                <FField  label="% of public t..." value={form.publicTPercent} onChange={s("publicTPercent")} placeholder="—"/>
                <FSelect label="Secure bike ..."  value={form.secureBike}  onChange={s("secureBike")}  options={["","Yes","No"]}/>
                <FField  label="% of cycling ..." value={form.cyclingPercent} onChange={s("cyclingPercent")} placeholder="—"/>
              </div>
              <div>
                <FSelect label="Charging sta..." value={form.chargingSta}  onChange={s("chargingSta")}  options={["","Yes","No","Planned"]}/>
                <FSelect label="Free-floating..." value={form.freeFloating} onChange={s("freeFloating")} options={["","Yes","No"]}/>
                <FField  label="% of drive-in ..." value={form.driveIn}    onChange={s("driveIn")}    placeholder="—"/>
                <FSelect label="Shower and l..."  value={form.showerAndL}  onChange={s("showerAndL")}  options={["","Yes","No"]}/>
                <FField  label="% of walking ..."  value={form.walkingPercent} onChange={s("walkingPercent")} placeholder="—"/>
              </div>
            </FRow2>
          </div>

          {/* ── Environment ── */}
          <div id="msi-Environment">
            <FSectionTitle>Môi trường</FSectionTitle>
            <FRow2>
              <div>
                <FSelect label="Climate risk ..." value={form.climateRisk}   onChange={s("climateRisk")}   options={["","Thấp","Medium","High","Very high"]}/>
                <FSelect label="Vegetal roof"     value={form.vegetalRoof}   onChange={s("vegetalRoof")}   options={["","Yes","No","Partial"]}/>
                <FSelect label="Semi-perme..."    value={form.semiPerme}     onChange={s("semiPerme")}     options={["","Yes","No"]}/>
                <FField  label="Climate risk ..." placeholder="—"/>
              </div>
              <div>
                <FField  label="Open groun..."    value={form.openGround}    onChange={s("openGround")}    placeholder="—"/>
                <FField  label="Non artificial..." value={form.nonArtificial} onChange={s("nonArtificial")} placeholder="—"/>
                <FSelect label="Close to pub..."  value={form.closeToPub}    onChange={s("closeToPub")}    options={["","Yes","No"]}/>
              </div>
            </FRow2>
            <div style={{height:40}}/>
          </div>
        </div>
      </div>

      {/* Right panel: Opening time */}
      <div style={{
        width:260,background:"white",borderLeft:"1px solid #e2e8f0",
        padding:"16px",flexShrink:0,overflowY:"auto"
      }}>
        <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:14}}>
          <div style={{width:10,height:10,borderRadius:"50%",background:"#2563eb",flexShrink:0}}/>
          <span style={{fontSize:12,fontWeight:700,color:"#0f172a"}}>Giờ mở cửa</span>
        </div>
        <div style={{fontSize:11,color:"#94a3b8",marginBottom:14}}>Chưa có lịch được cấu hình</div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(6,1fr)",gap:2,marginBottom:4}}>
          {["Mon","Tue","Wed","Thu","Fri","Sat"].map(d=>(
            <div key={d} style={{fontSize:9,color:"#94a3b8",textAlign:"center"}}>{d}</div>
          ))}
        </div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(6,1fr)",gap:2}}>
          {Array.from({length:24}).map((_,i)=>(
            <div key={i} style={{height:20,background:"#f1f5f9",borderRadius:2}}/>
          ))}
        </div>
      </div>
    </div>
  )
}

function MySiteTab() {
  const [subTab,        setSubTab]        = useState("Sơ đồ đo lường")
  const [selectedMeter, setSelectedMeter] = useState(null)
  const [sensorPopup,   setSensorPopup]   = useState(null) // {meter, position}
  const [selectedSensor,setSelectedSensor]= useState(null)
  const [sensorModal,   setSensorModal]   = useState(null)
  const [expandAll,     setExpandAll]     = useState(true)

  const subTabs = ["Sơ đồ đo lường","My Site","Cảm biến","Lô","Mô hình"]

  const handleMeterClick = (fluid, meter, e) => {
    e.stopPropagation()
    if (selectedMeter?.id === meter.id) { setSelectedMeter(null); setSensorPopup(null); return }
    setSelectedMeter({...meter, fluid})
    setSensorPopup(null)
    setSelectedSensor(null)
  }

  const handleMeterDoubleClick = (fluid, meter, e) => {
    e.stopPropagation()
    const rect = e.currentTarget.getBoundingClientRect()
    setSensorPopup({ meter, fluid, x: rect.left, y: rect.bottom + 4 })
    setSelectedMeter({...meter, fluid})
  }

  const handleSensorClick = (sensor, meter) => {
    setSelectedSensor({...sensor, meterName: meter.name})
    setSensorPopup(null)
  }

  return (
    <div style={{display:"flex",flexDirection:"column",height:"100%",background:"#f8fafc"}}
      onClick={()=>setSensorPopup(null)}>

      {/* Sub-tab bar */}
      <div style={{
        background:"white",borderBottom:"1px solid #e2e8f0",
        padding:"0 16px",display:"flex",alignItems:"center",gap:4,flexShrink:0,
        boxShadow:"0 1px 3px rgba(0,0,0,0.04)"
      }}>
        {subTabs.map(t=>(
          <button key={t} onClick={()=>setSubTab(t)} style={{
            padding:"10px 14px",border:"none",cursor:"pointer",fontSize:12,fontWeight:500,
            background:subTab===t?"#1e3a5f":"transparent",
            color:subTab===t?"white":"#64748b",
            borderRadius:subTab===t?6:0,
            transition:"all .15s",whiteSpace:"nowrap"
          }}>{t}</button>
        ))}
        <div style={{flex:1}}/>
        <button onClick={()=>setExpandAll(false)} style={{background:"none",border:"none",cursor:"pointer",fontSize:12,color:"#64748b"}}>Reduce all</button>
        <button onClick={()=>setExpandAll(true)}  style={{background:"none",border:"none",cursor:"pointer",fontSize:12,color:"#2563eb",fontWeight:600,marginLeft:6}}>Expand All</button>
        <button style={{
          width:30,height:30,borderRadius:"50%",background:"#f59e0b",border:"none",
          cursor:"pointer",marginLeft:10,fontSize:14,display:"flex",alignItems:"center",justifyContent:"center",
          boxShadow:"0 2px 6px rgba(245,158,11,.35)"
        }}>✏</button>
      </div>

      {subTab === "Sơ đồ đo lường" ? (
        <div style={{flex:1,display:"flex",overflow:"hidden"}}>

          {/* 3 columns: SUPPLIES | TRANSFORMATIONS | USAGES */}
          <div style={{flex:1,display:"flex",overflow:"auto"}}>

            {/* SUPPLIES */}
            <div style={{flex:1,borderRight:"1px solid #e2e8f0",overflowY:"auto",padding:12}}>
              <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:12}}>
                <span style={{fontSize:11,fontWeight:700,color:"#64748b",letterSpacing:1}}>SUPPLIES</span>
                <button style={{width:22,height:22,borderRadius:"50%",background:"none",border:"1px solid #cbd5e1",cursor:"pointer",fontSize:14,display:"flex",alignItems:"center",justifyContent:"center",color:"#64748b"}}>+</button>
              </div>
              {Object.entries(METER_DATA).map(([fluid, data])=>(
                <div key={fluid} style={{
                  background:"white",borderRadius:8,border:"1px solid #e2e8f0",
                  marginBottom:10,overflow:"hidden",
                  boxShadow:selectedMeter?.fluid===fluid?"0 0 0 2px "+FLUID_COLORS[fluid]:"none"
                }}>
                  <div style={{
                    display:"flex",alignItems:"center",gap:6,padding:"8px 12px",
                    borderBottom:expandAll?"1px solid #f1f5f9":"none",cursor:"pointer",
                  }} onClick={()=>setExpandAll(e=>!e)}>
                    <span style={{fontSize:14}}>{FLUID_ICONS[fluid]}</span>
                    <span style={{fontSize:12,fontWeight:600,color:FLUID_COLORS[fluid]}}>
                      {fluid} ({data.meters.length})
                    </span>
                  </div>
                  {expandAll && data.meters.map(meter=>(
                    <div key={meter.id}
                      onClick={(e)=>handleMeterClick(fluid,meter,e)}
                      onDoubleClick={(e)=>handleMeterDoubleClick(fluid,meter,e)}
                      style={{
                        padding:"10px 16px",cursor:"pointer",
                        background:selectedMeter?.id===meter.id?"#eff6ff":"transparent",
                        transition:"background .15s"
                      }}
                      onMouseEnter={e=>{if(selectedMeter?.id!==meter.id)e.currentTarget.style.background="#f8fafc"}}
                      onMouseLeave={e=>{if(selectedMeter?.id!==meter.id)e.currentTarget.style.background="transparent"}}
                    >
                      <MeterIcon color={FLUID_COLORS[fluid]} active={selectedMeter?.id===meter.id}/>
                    </div>
                  ))}
                </div>
              ))}
            </div>

            {/* TRANSFORMATIONS */}
            <div style={{flex:1,borderRight:"1px solid #e2e8f0",padding:12}}>
              <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:12}}>
                <span style={{fontSize:11,fontWeight:700,color:"#64748b",letterSpacing:1}}>TRANSFORMATIONS</span>
                <button style={{width:22,height:22,borderRadius:"50%",background:"none",border:"1px solid #cbd5e1",cursor:"pointer",fontSize:14,display:"flex",alignItems:"center",justifyContent:"center",color:"#64748b"}}>+</button>
              </div>
              <div style={{display:"flex",alignItems:"center",justifyContent:"center",height:200,color:"#e2e8f0",fontSize:11}}>—</div>
            </div>

            {/* USAGES */}
            <div style={{flex:1,padding:12}}>
              <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:12}}>
                <span style={{fontSize:11,fontWeight:700,color:"#64748b",letterSpacing:1}}>USAGES</span>
                <button style={{width:22,height:22,borderRadius:"50%",background:"none",border:"1px solid #cbd5e1",cursor:"pointer",fontSize:14,display:"flex",alignItems:"center",justifyContent:"center",color:"#64748b"}}>+</button>
              </div>
              <div style={{display:"flex",alignItems:"center",justifyContent:"center",height:200,color:"#e2e8f0",fontSize:11}}>—</div>
            </div>
          </div>

          {/* Right detail panel */}
          <div style={{
            width:260,background:"white",borderLeft:"1px solid #e2e8f0",
            display:"flex",flexDirection:"column",flexShrink:0,overflow:"auto"
          }}>
            {!selectedMeter && !selectedSensor && (
              <div style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center",color:"#94a3b8",fontSize:12}}>
                No object selected
              </div>
            )}

            {/* Meter info panel */}
            {selectedMeter && !selectedSensor && (
              <div>
                <div style={{padding:"10px 14px",borderBottom:"1px solid #f1f5f9",background:"#f8fafc"}}>
                  <span style={{fontSize:10,color:"#64748b"}}>meter · </span>
                  <span style={{fontSize:12,fontWeight:700,color:"#0f172a"}}>{selectedMeter.name}</span>
                </div>
                <div style={{padding:"6px 0",borderBottom:"1px solid #f1f5f9"}}>
                  <button style={{
                    padding:"8px 16px",background:"none",border:"none",cursor:"pointer",
                    fontSize:12,fontWeight:700,color:"#2563eb",borderBottom:"2px solid #2563eb"
                  }}>Thông tin</button>
                </div>
                {[
                  ["Name",            selectedMeter.name],
                  ["Code",            selectedMeter.code],
                  ["Delivery point",  selectedMeter.deliveryPoint],
                  ["Meter type",      selectedMeter.meterType],
                  ["Type of entry",   selectedMeter.typeOfEntry],
                  ["Fluid",           selectedMeter.fluid],
                  ["Description of the fl...", "—"],
                  ["Unit",            selectedMeter.unit],
                  ["CO₂ coefficient", ""],
                  ["High threshold",  ""],
                  ["Low threshold",   ""],
                  ["Pulse weight",    ""],
                  ["Data source",     selectedMeter.dataSource],
                ].map(([k,v])=>(
                  <div key={k} style={{
                    display:"flex",justifyContent:"space-between",alignItems:"center",
                    padding:"6px 14px",borderBottom:"1px solid #f8fafc",gap:8
                  }}>
                    <span style={{fontSize:11,color:"#64748b",flexShrink:0}}>{k}</span>
                    <span style={{fontSize:11,fontWeight:600,color:"#0f172a",textAlign:"right"}}>{v||"—"}</span>
                  </div>
                ))}
                <div style={{padding:"8px 14px",background:"#f8fafc",fontSize:10,fontWeight:700,color:"#94a3b8",letterSpacing:1}}>
                  LAST YEAR SLIDING
                </div>
              </div>
            )}

            {/* Sensor info panel */}
            {selectedSensor && (
              <div>
                <div style={{padding:"10px 14px",borderBottom:"1px solid #f1f5f9",background:"#f8fafc"}}>
                  <span style={{fontSize:10,color:"#64748b"}}>Sensor · </span>
                  <span style={{fontSize:12,fontWeight:700,color:"#0f172a"}}>{selectedSensor.name}</span>
                </div>
                <div style={{padding:"0",borderBottom:"1px solid #f1f5f9",display:"flex"}}>
                  {["Thông tin","Cảnh báo"].map(t=>(
                    <button key={t} style={{
                      padding:"8px 14px",background:"none",border:"none",cursor:"pointer",
                      fontSize:12,fontWeight:700,
                      color:"#2563eb",
                      borderBottom:"2px solid #2563eb"
                    }}>{t}</button>
                  ))}
                </div>
                {[
                  ["Name",         selectedSensor.name],
                  ["Sensor type",  selectedSensor.sensorType],
                  ["Source",       selectedSensor.source],
                  ["Brand",        selectedSensor.brand],
                  ["Template",     ""],
                  ["Module",       selectedSensor.module],
                  ["Channel used", selectedSensor.channel],
                  ["Identifier",   selectedSensor.identifier],
                  ["Date of commission...", selectedSensor.commission],
                  ["Uninstallation date",  selectedSensor.uninstall||"—"],
                  ["Time resolution",      selectedSensor.resolution],
                ].map(([k,v])=>(
                  <div key={k} style={{
                    display:"flex",justifyContent:"space-between",alignItems:"flex-start",
                    padding:"6px 14px",borderBottom:"1px solid #f8fafc",gap:8
                  }}>
                    <span style={{fontSize:11,color:"#64748b",flexShrink:0}}>{k}</span>
                    <span style={{fontSize:10,fontWeight:600,color:"#0f172a",textAlign:"right",wordBreak:"break-all"}}>{v||"—"}</span>
                  </div>
                ))}
                <div style={{padding:"8px 14px",background:"#f8fafc",fontSize:10,fontWeight:700,color:"#94a3b8",letterSpacing:1,cursor:"pointer"}}
                  onClick={()=>setSensorModal(selectedSensor)}>
                  LAST WEEK ›
                </div>
                <div style={{padding:"0 14px 8px"}} onClick={()=>setSensorModal(selectedSensor)}>
                  <MiniBarChart color="#22c55e" count={18}/>
                </div>
              </div>
            )}
          </div>
        </div>
      ) : subTab === "My Site" ? (
        <MySiteInfoPanel/>
      ) : subTab === "Cảm biến" ? (
        <SensorsPanel/>
      ) : (
        <div style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center",color:"#94a3b8",flexDirection:"column",gap:8}}>
          <span style={{fontSize:28}}>🚧</span>
          <span style={{fontSize:13,fontWeight:600}}>{subTab}</span>
          <span style={{fontSize:11}}>Coming soon</span>
        </div>
      )}

      {/* Sensor popup menu (Image 3) */}
      {sensorPopup && (
        <div style={{
          position:"fixed",
          top: Math.min(sensorPopup.y, window.innerHeight-120),
          left: Math.min(sensorPopup.x, window.innerWidth-220),
          background:"white",borderRadius:8,border:"1px solid #e2e8f0",
          boxShadow:"0 8px 24px rgba(0,0,0,0.15)",zIndex:500,minWidth:200,overflow:"hidden"
        }} onClick={e=>e.stopPropagation()}>
          {sensorPopup.meter.sensors.map((s,i)=>(
            <div key={s.id} onClick={()=>handleSensorClick(s, sensorPopup.meter)} style={{
              padding:"10px 14px",cursor:"pointer",fontSize:12,fontWeight:500,
              background: i===0?"#2563eb":"white",
              color: i===0?"white":"#374151",
              transition:"background .15s"
            }}
              onMouseEnter={e=>{if(i!==0)e.currentTarget.style.background="#f8fafc"}}
              onMouseLeave={e=>{if(i!==0)e.currentTarget.style.background="white"}}
            >{s.name}</div>
          ))}
        </div>
      )}

      {/* Sensor detail modal (Image 4) */}
      {sensorModal && (
        <SensorModal sensor={sensorModal} meter={selectedMeter} onClose={()=>setSensorModal(null)}/>
      )}
    </div>
  )
}

// ─── Site Detail ──────────────────────────────────────────
function SiteDetail({ site, onBack }) {
  const [activeTab,    setActiveTab]    = useState("Tổng quan")
  const [dashDropdown, setDashDropdown] = useState(false)
  const [activeDash,   setActiveDash]   = useState(0)
  const [linked,       setLinked]       = useState(false)
  const [showPicker,   setShowPicker]   = useState(false)
  const [period,       setPeriod]       = useState("06/06/2023 - 06/06/2024")

  return (
    <div style={{display:"flex",flexDirection:"column",height:"100%",background:"#f1f5f9"}}>

      {/* Site top bar */}
      <div style={{
        background:"white",borderBottom:"1px solid #e2e8f0",
        display:"flex",alignItems:"center",padding:"0 16px",height:48,
        gap:8,flexShrink:0,boxShadow:"0 1px 3px rgba(0,0,0,0.05)"
      }}>
        <button onClick={onBack} style={{
          background:"none",border:"none",cursor:"pointer",
          display:"flex",alignItems:"center",gap:6,color:"#64748b",fontSize:13,fontWeight:500,
          padding:"4px 8px",borderRadius:6,whiteSpace:"nowrap",transition:"background .15s"
        }}
          onMouseEnter={e=>e.currentTarget.style.background="#f1f5f9"}
          onMouseLeave={e=>e.currentTarget.style.background="none"}
        >← {site.id} · {site.name.toUpperCase()}</button>

        <div style={{flex:1,display:"flex",gap:0,overflowX:"auto"}}>
          {SITE_NAV.map(tab=>(
            <button key={tab} onClick={()=>setActiveTab(tab)} style={{
              background:"none",border:"none",cursor:"pointer",
              padding:"0 14px",height:48,fontSize:13,whiteSpace:"nowrap",
              fontWeight:activeTab===tab?600:400,
              color:activeTab===tab?"#2563eb":"#64748b",
              borderBottom:activeTab===tab?"2px solid #2563eb":"2px solid transparent",
              transition:"all .2s"
            }}>{tab}</button>
          ))}
        </div>

        <div style={{display:"flex",alignItems:"center",gap:8,flexShrink:0}}>
          <div style={{display:"flex",alignItems:"center",gap:6,fontSize:11,color:"#64748b"}}>
            <span>🏢</span><span>25 địa điểm</span>
          </div>
          <button style={{background:"#fef3c7",border:"none",borderRadius:6,padding:"3px 10px",cursor:"pointer",fontSize:13}}>✏</button>
          <button style={{background:"none",border:"none",cursor:"pointer",fontSize:15,color:"#94a3b8"}}>⋯</button>
        </div>
      </div>

      {activeTab === "Tổng quan" ? (
        <div style={{display:"flex",flex:1,overflow:"hidden"}}>

          {/* Left info panel */}
          <div style={{width:230,background:"white",borderRight:"1px solid #e2e8f0",display:"flex",flexDirection:"column",flexShrink:0,overflow:"auto"}}>

            {/* Dashboard selector */}
            <div style={{padding:"10px 12px",borderBottom:"1px solid #f1f5f9",position:"relative"}}>
              <button onClick={()=>setDashDropdown(!dashDropdown)} style={{
                display:"flex",alignItems:"center",justifyContent:"space-between",
                width:"100%",background:"none",border:"none",cursor:"pointer",
                fontWeight:700,fontSize:13,color:"#0f172a",padding:"4px 6px",borderRadius:6
              }}>
                <span>{DASHBOARDS_SITE[activeDash].label}</span>
                <span style={{color:"#94a3b8",fontSize:11}}>▾</span>
              </button>
              {dashDropdown && (
                <div style={{
                  position:"absolute",top:"100%",left:8,right:8,background:"white",
                  border:"1px solid #e2e8f0",borderRadius:8,padding:4,zIndex:200,
                  boxShadow:"0 6px 20px rgba(0,0,0,0.12)"
                }}>
                  {DASHBOARDS_SITE.map(d=>(
                    <div key={d.id} onClick={()=>{setActiveDash(d.id);setDashDropdown(false)}} style={{
                      padding:"8px 10px",borderRadius:6,cursor:"pointer",fontSize:12,
                      background:d.id===activeDash?"#eff6ff":"transparent",
                      color:d.id===activeDash?"#2563eb":"#374151",fontWeight:d.id===activeDash?600:400
                    }}
                      onMouseEnter={e=>{if(d.id!==activeDash)e.currentTarget.style.background="#f8fafc"}}
                      onMouseLeave={e=>{if(d.id!==activeDash)e.currentTarget.style.background="transparent"}}
                    >
                      {d.icon&&<span style={{marginRight:6}}>{d.icon}</span>}
                      {d.label}
                      {d.subtitle&&<div style={{fontSize:9,color:"#94a3b8",marginTop:1}}>{d.subtitle}</div>}
                    </div>
                  ))}
                  <div style={{borderTop:"1px solid #f1f5f9",padding:"6px 10px"}}>
                    <button style={{background:"none",border:"none",cursor:"pointer",fontSize:10,color:"#64748b"}}>⚙ Manage analysis</button>
                  </div>
                </div>
              )}
            </div>

            {/* Site info */}
            <div style={{padding:"4px 0",flex:1}}>
              {[
                ["Name",        site.name],
                ["Address",     site.address],
                ["City",        site.city],
                ["Country",     site.country],
                ["Typology",    site.typology],
                ["Total surf.", `${site.totalSurf} m²`],
                ["Useful surf.",`${site.usefulSurf} m²`],
                ["Heated vol.", site.heatedVol],
                ["Number of...",site.numberOfFloors],
                ["Total vol...",site.totalVol],
              ].map(([k,v])=>(
                <div key={k} style={{display:"flex",gap:8,padding:"5px 14px",borderBottom:"1px solid #f8fafc",cursor:"default",transition:"background .1s"}}
                  onMouseEnter={e=>e.currentTarget.style.background="#f8fafc"}
                  onMouseLeave={e=>e.currentTarget.style.background="transparent"}
                >
                  <span style={{fontSize:11,color:"#64748b",flexShrink:0,width:80,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{k}</span>
                  <span style={{fontSize:11,color:"#0f172a",fontWeight:500,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{v}</span>
                </div>
              ))}
            </div>

            {/* Link widget toggle */}
            <div style={{padding:"10px 14px",borderTop:"1px solid #f1f5f9",display:"flex",alignItems:"center",gap:8}}>
              <span style={{fontSize:11,color:"#64748b",flex:1}}>Liên kết khoảng thời gian</span>
              <button onClick={()=>setLinked(!linked)} style={{
                width:34,height:18,borderRadius:9,background:linked?"#2563eb":"#cbd5e1",
                border:"none",cursor:"pointer",position:"relative",transition:"background .2s"
              }}>
                <div style={{width:12,height:12,borderRadius:"50%",background:"white",position:"absolute",top:3,left:linked?19:3,transition:"left .2s"}}/>
              </button>
            </div>
          </div>

          {/* Right — widgets */}
          <div style={{flex:1,overflowY:"auto",padding:14}}>
            {activeDash===0 && <OverviewDashboard site={site} period={period} onDateClick={()=>setShowPicker(true)}/>}
            {activeDash===1 && <CO2SiteDashboard  site={site} period={period} onDateClick={()=>setShowPicker(true)}/>}
          </div>
        </div>
      ) : activeTab === "Địa điểm tôi" ? (
        <MySiteTab/>
      ) : activeTab === "Lưu Trình Công Nghệ" ? (
        <SynopticPanel site={site}/>
      ) : activeTab === "Kế hoạch" ? (
        <div style={{display:"flex",flexDirection:"column",flex:1,overflow:"hidden"}}>
          {/* Action plans header */}
          <div style={{
            background:"white",borderBottom:"1px solid #e2e8f0",
            padding:"12px 20px",display:"flex",alignItems:"center",justifyContent:"space-between",flexShrink:0
          }}>
            <div style={{
              background:"#1e3a5f",color:"white",fontWeight:700,fontSize:13,
              padding:"6px 16px",borderRadius:6,letterSpacing:.3
            }}>Kế hoạch</div>
            <button style={{
              width:32,height:32,borderRadius:"50%",background:"#22c55e",border:"none",
              cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",
              color:"white",fontSize:20,fontWeight:300,boxShadow:"0 2px 8px rgba(34,197,94,0.4)"
            }}>+</button>
          </div>
          <div style={{flex:1,overflow:"hidden"}}>
            <ActionPlanBoard siteId={site.id}/>
          </div>
        </div>
      ) : (
        <div style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center",color:"#94a3b8",flexDirection:"column",gap:8}}>
          <span style={{fontSize:32}}>🚧</span>
          <span style={{fontSize:14,fontWeight:600}}>{activeTab}</span>
          <span style={{fontSize:12}}>Sắp ra mắt — Sprint 2</span>
        </div>
      )}

      {/* Period Picker Modal */}
      {showPicker && (
        <PeriodPicker
          current={period}
          onClose={()=>setShowPicker(false)}
          onApply={(p)=>{setPeriod(p);setShowPicker(false)}}
        />
      )}
    </div>
  )
}

// ─── Sites List ───────────────────────────────────────────
export default function SitesPage() {
  const [selectedSite, setSelectedSite] = useState(null)
  const [search,       setSearch]       = useState("")

  if (selectedSite) return <SiteDetail site={selectedSite} onBack={()=>setSelectedSite(null)}/>

  const filtered = SITES.filter(s =>
    s.name.toLowerCase().includes(search.toLowerCase()) ||
    s.id.toLowerCase().includes(search.toLowerCase()) ||
    s.city.toLowerCase().includes(search.toLowerCase())
  )

  return (
    <div style={{padding:24,display:"flex",flexDirection:"column",gap:16,height:"100%",overflow:"auto"}}>
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:12}}>
        <div>
          <h2 style={{fontSize:20,fontWeight:800,color:"#0f172a",margin:0}}>Địa điểm</h2>
          <p style={{fontSize:12,color:"#64748b",margin:"2px 0 0"}}>{SITES.length} sites monitored</p>
        </div>
        <div style={{display:"flex",gap:10}}>
          <div style={{display:"flex",background:"white",border:"1px solid #e2e8f0",borderRadius:6,padding:"6px 12px",gap:6,width:220}}>
            <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search site..."
              style={{border:"none",outline:"none",fontSize:12,flex:1,background:"transparent"}}/>
            <span style={{color:"#94a3b8"}}>🔍</span>
          </div>
          <button style={{background:"#2563eb",border:"none",borderRadius:6,padding:"6px 14px",color:"white",fontWeight:600,fontSize:13,cursor:"pointer"}}>+ Add site</button>
        </div>
      </div>

      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(280px,1fr))",gap:12}}>
        {filtered.map(site=>{
          const classIdx=["A","B","C","D","E","F"].indexOf(site.energyClass)
          return (
            <div key={site.id} onClick={()=>setSelectedSite(site)} style={{
              background:"white",borderRadius:10,padding:18,cursor:"pointer",
              boxShadow:"0 1px 4px rgba(0,0,0,0.07)",border:"1px solid #f1f5f9",transition:"all .2s"
            }}
              onMouseEnter={e=>{e.currentTarget.style.boxShadow="0 6px 16px rgba(0,0,0,0.1)";e.currentTarget.style.transform="translateY(-2px)"}}
              onMouseLeave={e=>{e.currentTarget.style.boxShadow="0 1px 4px rgba(0,0,0,0.07)";e.currentTarget.style.transform="translateY(0)"}}
            >
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:12}}>
                <div>
                  <div style={{fontSize:10,color:"#64748b",fontWeight:600,letterSpacing:.5}}>{site.id}</div>
                  <div style={{fontSize:14,fontWeight:700,color:"#0f172a",marginTop:2}}>{site.name}</div>
                  <div style={{fontSize:11,color:"#94a3b8",marginTop:1}}>{site.city}, {site.country}</div>
                </div>
                <div style={{
                  background:ENERGY_COLORS[classIdx],color:"white",fontWeight:800,fontSize:14,
                  width:32,height:32,borderRadius:6,display:"flex",alignItems:"center",justifyContent:"center"
                }}>{site.energyClass}</div>
              </div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:12}}>
                {[
                  {label:"Surface",    value:`${site.totalSurf.toLocaleString()} m²`},
                  {label:"Typology",   value:site.typology},
                  {label:"Tiêu thụ",value:`${site.consumption} kWh/m²`},
                  {label:"CO₂",        value:`${site.co2} kgCO₂/m²`},
                ].map(s=>(
                  <div key={s.label} style={{background:"#f8fafc",borderRadius:6,padding:"6px 10px"}}>
                    <div style={{fontSize:9,color:"#94a3b8",fontWeight:600,marginBottom:2}}>{s.label}</div>
                    <div style={{fontSize:12,fontWeight:700,color:"#0f172a"}}>{s.value}</div>
                  </div>
                ))}
              </div>
              <div style={{display:"flex",justifyContent:"flex-end"}}>
                <span style={{fontSize:11,color:"#2563eb",fontWeight:600}}>View details →</span>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
